/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 353:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),

/***/ 172:
/***/ ((module) => {

function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 993:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var regeneratorDefine = __webpack_require__(546);
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 869:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var regeneratorAsyncGen = __webpack_require__(887);
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var regenerator = __webpack_require__(993);
var regeneratorAsyncIterator = __webpack_require__(791);
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var OverloadYield = __webpack_require__(172);
var regeneratorDefine = __webpack_require__(546);
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 546:
/***/ ((module) => {

function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 373:
/***/ ((module) => {

function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var OverloadYield = __webpack_require__(172);
var regenerator = __webpack_require__(993);
var regeneratorAsync = __webpack_require__(869);
var regeneratorAsyncGen = __webpack_require__(887);
var regeneratorAsyncIterator = __webpack_require__(791);
var regeneratorKeys = __webpack_require__(373);
var regeneratorValues = __webpack_require__(579);
function _regeneratorRuntime() {
  "use strict";

  var r = regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(738)["default"]);
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 738:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(633)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";

;// ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

;// ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function asyncToGenerator_asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != typeof_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof_typeof(i) ? i : i + "";
}

;// ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

;// ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

;// ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof_typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

;// ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

;// ./node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

;// ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(756);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// ./src/js/utils/isDefined.ts
function isDefined_isDefined(t) {
  return t !== undefined;
}
;// ./src/js/api/cart.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Common cart-item shape shared across Shopify Ajax API endpoints
 * (`/cart/add.js`, `/cart/update.js`, `/cart.js`, etc.).
 *
 * `id`, `price`, and `sku` overlap with {@link ProductVariantAttributes} but
 * Shopify serializes snake_case in Ajax responses (keeping camelCase for
 * `weightUnit` was an explicit choice in the projection types; we don't leak
 * that convention into Ajax response shapes).
 *
 * @see https://shopify.dev/docs/api/ajax/reference/cart
 */

/**
 * Full cart returned by GET `/cart.js` and POST `/cart/change.js` and
 * `/cart/update.js`, narrowed to the fields the theme reads. The index
 * signature keeps the remaining Ajax cart fields reachable for passthrough
 * without spelling out the whole document.
 *
 * @see https://shopify.dev/docs/api/ajax/reference/cart#get--locale-cartjs
 */

/**
 * Cart returned by POST `/{locale}/cart/change.js`: the full cart (not a single
 * line), plus any sections requested alongside it.
 *
 * @see https://shopify.dev/docs/api/ajax/reference/cart#post--locale-cart-changejs
 */

/**
 * Cart item returned by POST `/{locale}/cart/add.js`.
 *
 * Currently identical to {@link AjaxApiBaseCartItem}; aliased so call-sites
 * express intent (add-to-cart response) and future endpoints can diverge.
 *
 * @see https://shopify.dev/docs/api/ajax/reference/cart#post--locale-cart-addjs
 */

/** @todo rename for payload clarity */

function cart_addItemToCart(item) {
  var sectionsOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addToCart(_objectSpread(_objectSpread({}, item), buildSectionsOptions(sectionsOptions)));
}
function addItemsToCart(items) {
  var sectionsOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addToCart(_objectSpread({
    items: items
  }, buildSectionsOptions(sectionsOptions)));
}

/**
 * Update a cart line's quantity via POST `/cart/change.js`, addressing the line
 * by its `key`. Unlike the legacy `cartApi.updateQty` (`utils/cart-api.ts`),
 * this rejects cleanly on failure WITHOUT firing a native `alert()`, leaving
 * error UX entirely to the caller.
 */
function changeCartLine(key, quantity) {
  var sectionsOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return fetcher('/cart/change.js', _objectSpread({
    id: key,
    quantity: quantity
  }, buildSectionsOptions(sectionsOptions)), 'POST');
}
function addToCart(_x) {
  return _addToCart.apply(this, arguments);
}
function _addToCart() {
  _addToCart = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(payload) {
    var fallbackError;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetcher('/cart/add.js', payload, 'POST');
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          fallbackError = new Error('Failed to add to cart');
          throw _context.t0 instanceof Error && _context.t0.message ? _context.t0 : fallbackError;
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _addToCart.apply(this, arguments);
}
function buildSectionsOptions(options) {
  return _objectSpread(_objectSpread({}, options.sections && {
    sections: options.sections
  }), options.sectionsUrl && {
    sections_url: options.sectionsUrl
  });
}
function fetcher(_x2, _x3, _x4) {
  return _fetcher.apply(this, arguments);
}
function _fetcher() {
  _fetcher = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(endpoint, payload, method) {
    var response, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch(endpoint, {
            method: method,
            headers: {
              'Content-Type': 'application/json'
            },
            body: method === 'POST' ? JSON.stringify(payload) : undefined
          });
        case 2:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 8;
            break;
          }
          _context2.next = 6;
          return response.json()["catch"](function () {
            return {};
          });
        case 6:
          data = _context2.sent;
          throw new Error(data.description || data.message);
        case 8:
          return _context2.abrupt("return", response.json());
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetcher.apply(this, arguments);
}
;// ./src/js/bundles/snippets/shipping-meter.js
/**
 * Shipping Meter - handles popover toggle and progress bar updates
 */

// Initialize shipping info popover functionality
var initShippingInfoPopover = function initShippingInfoPopover(container) {
  if (!container) return;
  var trigger = container.querySelector('[data-shipping-info-trigger]');
  var popover = container.querySelector('[data-shipping-info-popover]');
  if (!trigger || !popover) return;
  var closeBtn = popover.querySelector('[data-shipping-info-close]');
  var hide = function hide() {
    popover.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  };
  var _closePopover = function closePopover(evt) {
    if (popover.contains(evt.target) || trigger.contains(evt.target)) return;
    hide();
    document.removeEventListener('click', _closePopover);
    document.removeEventListener('keydown', _handleKeydown);
  };
  var _handleKeydown = function handleKeydown(evt) {
    if (evt.key === 'Escape') {
      hide();
      trigger.focus();
      document.removeEventListener('click', _closePopover);
      document.removeEventListener('keydown', _handleKeydown);
    }
  };
  trigger.addEventListener('click', function (evt) {
    evt.stopPropagation();
    var isHidden = popover.hidden;
    if (isHidden) {
      popover.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        return document.addEventListener('click', _closePopover);
      }, 0);
      document.addEventListener('keydown', _handleKeydown);
    } else {
      _closePopover(evt);
    }
  });
  if (closeBtn) {
    closeBtn.addEventListener('click', function (evt) {
      evt.stopPropagation();
      hide();
      document.removeEventListener('click', _closePopover);
      document.removeEventListener('keydown', _handleKeydown);
      trigger.focus();
    });
  }
};

// Update shipping meter progress based on cart total
var shipping_meter_updateShippingMeter = function updateShippingMeter(cartTotalCents, threshHold) {
  var meters = document.querySelectorAll('[data-shipping-meter]');
  if (!meters.length) return;
  meters.forEach(function (meter) {
    var thresholdCents = threshHold ? threshHold * 100 : parseInt(meter.dataset.thresholdCents, 10) || 0;
    if (thresholdCents <= 0) return;
    var successHtml = meter.dataset.successHtml || 'YAY! You qualify for FREE shipping!';
    var remaining = Math.max(thresholdCents - cartTotalCents, 0);
    var progress = Math.floor(Math.min(cartTotalCents / thresholdCents * 100, 100));

    // Update progress bar
    var bar = meter.querySelector('[data-shipping-meter-bar]');
    if (bar) {
      bar.style.width = "".concat(progress, "%");
    }

    // Update screen reader text
    var srText = meter.querySelector('[data-shipping-meter-sr]');
    if (srText) {
      srText.textContent = "Shipping meter at ".concat(progress, " percent");
    }

    // Update message
    var messageEl = meter.querySelector('[data-shipping-meter-message]');
    if (messageEl) {
      if (remaining > 0) {
        var remainingFormatted = formatMoney(remaining);
        messageEl.innerHTML = "Add <strong class=\"font-semibold\">".concat(remainingFormatted, " more</strong> for FREE shipping!");
      } else {
        messageEl.innerHTML = successHtml;
      }
    }
  });
};

// Format cents to money string
var formatMoney = function formatMoney(cents) {
  var dollars = (cents / 100).toFixed(2);
  return "$".concat(dollars);
};

// Initialize all shipping meters on the page
var initShippingMeter = function initShippingMeter() {
  var meters = document.querySelectorAll('[data-shipping-meter]');
  meters.forEach(function (meter) {
    initShippingInfoPopover(meter);
  });
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(353);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// ./src/js/utils/delivery-estimate.js



var ZIP_STORAGE_KEY = 'pdp_delivery_estimate_zipcode';
var US_ZIP_REGEX = /^\d{5}(-?\d{4})?$/;
var CA_POSTAL_REGEX = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
function sanitizePostalCode(value) {
  if (!value) return null;
  return String(value).replace(/[<>"'=]/g, '');
}
function getStoredZip() {
  try {
    var zipcode = localStorage.getItem(ZIP_STORAGE_KEY);
    return zipcode ? sanitizePostalCode(zipcode) : null;
  } catch (_unused) {
    return null;
  }
}
function setStoredZip(zip) {
  try {
    var safeZip = sanitizePostalCode(zip);
    localStorage.setItem(ZIP_STORAGE_KEY, safeZip);
  } catch (_unused2) {
    // ignore
  }
}
function clearStoredZip() {
  try {
    localStorage.removeItem(ZIP_STORAGE_KEY);
  } catch (_unused3) {
    // ignore
  }
}
function isValidPostalCode(value) {
  if (!value) return false;
  return US_ZIP_REGEX.test(value) || CA_POSTAL_REGEX.test(value);
}
function isCanadaPostalCode(value) {
  return CA_POSTAL_REGEX.test(value);
}

// One lookup per page: variant switches reuse it instead of re-hiding the ZIP
// form for another round-trip. The timeout caps how long its row sits blank.
var ipZipPromise = null;
function fetchZipFromIpApi() {
  if (!ipZipPromise) {
    ipZipPromise = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _AbortSignal$timeout, _AbortSignal, res, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch('https://ipapi.co/json/', {
              // Optional call: browsers without AbortSignal.timeout fetch with no cap.
              signal: (_AbortSignal$timeout = (_AbortSignal = AbortSignal).timeout) === null || _AbortSignal$timeout === void 0 ? void 0 : _AbortSignal$timeout.call(_AbortSignal, 3000)
            });
          case 3:
            res = _context.sent;
            if (res.ok) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", null);
          case 6:
            _context.next = 8;
            return res.json();
          case 8:
            data = _context.sent;
            return _context.abrupt("return", (data === null || data === void 0 ? void 0 : data.postal) || null);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }))();
  }
  return ipZipPromise;
}
function buildShippingPayload(zip, variantData) {
  return {
    shipments: [{
      address: {
        country: 'US',
        residential: true,
        postalCode: zip
      },
      key: 'Address 1',
      lines: [{
        sku: variantData.sku,
        quantity: variantData.quantity,
        weight: variantData.weight
      }],
      shipmentValue: {
        fractionDigits: 2,
        type: 'centPrecision',
        currencyCode: 'USD',
        centAmount: variantData.price
      }
    }],
    allowAmazonShipping: true,
    allowBlueStreak: true,
    allowCdl: true,
    allowDashlink: true,
    allowGrandHusky: true,
    allowLasership: true,
    allowOntrac: true,
    allowShipx: true,
    allowTforce: true,
    allowUds: true
  };
}
function fetchMainShippingEstimate(_x, _x2) {
  return _fetchMainShippingEstimate.apply(this, arguments);
}
function _fetchMainShippingEstimate() {
  _fetchMainShippingEstimate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(zip, variantData) {
    var payload, res, _message, message, _data$errors, data, err;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          payload = buildShippingPayload(zip, variantData);
          _context2.next = 3;
          return fetch('https://nuts.com/api/shipping-calculator', {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload)
          });
        case 3:
          res = _context2.sent;
          if (res.ok) {
            _context2.next = 18;
            break;
          }
          message = '';
          _context2.prev = 6;
          _context2.next = 9;
          return res.json();
        case 9:
          data = _context2.sent;
          message = (data === null || data === void 0 || (_data$errors = data.errors) === null || _data$errors === void 0 || (_data$errors = _data$errors[0]) === null || _data$errors === void 0 ? void 0 : _data$errors.message) || '';
          _context2.next = 15;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](6);
        case 15:
          err = new Error('Main shipping API failed');
          err.isPostalError = res.status === 400 && ((_message = message) === null || _message === void 0 ? void 0 : _message.toLowerCase().includes('postal'));
          throw err;
        case 18:
          return _context2.abrupt("return", res.json());
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 13]]);
  }));
  return _fetchMainShippingEstimate.apply(this, arguments);
}
function fetchPredictedShippingEstimate() {
  return _fetchPredictedShippingEstimate.apply(this, arguments);
}
function _fetchPredictedShippingEstimate() {
  _fetchPredictedShippingEstimate = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
    var res;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fetch('https://nuts.com/api/predicted-shipping', {
            method: 'GET',
            mode: 'cors'
          });
        case 2:
          res = _context3.sent;
          if (res.ok) {
            _context3.next = 5;
            break;
          }
          throw new Error('Predictive shipping API failed');
        case 5:
          return _context3.abrupt("return", res.json());
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchPredictedShippingEstimate.apply(this, arguments);
}
function formatArrivalLabel(iso) {
  if (!iso) return null;
  var currentDate = dayjs().startOf('day');
  var date = dayjs(iso);
  var diff = date.diff(currentDate, 'day');
  var dateText = date.format('MMMM D');
  if (diff === 0) {
    return "<strong>Today</strong>, ".concat(dateText);
  }
  if (diff === 1) {
    return "<strong>Tomorrow</strong>, ".concat(dateText);
  }
  var weekday = date.format('dddd');
  return "<strong>".concat(weekday, "</strong>, ").concat(dateText);
}
function formatCutoffTime(iso) {
  if (!iso) return '';
  var now = dayjs();
  var cutoff = dayjs(iso);
  var diff = cutoff.diff(now, 'second');
  if (diff <= 0) return '';
  var hrs = Math.floor(diff / 3600);
  var mins = Math.floor(diff % 3600 / 60);
  if (hrs > 0) return "".concat(hrs, " hrs ").concat(mins, " mins.");
  return "".concat(mins, " mins.");
}
function formatMainShippingMessage(apiData) {
  var _apiData$data, _offerSet$shippingOff, _address$city;
  var offerSet = apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 || (_apiData$data = _apiData$data.offerSets) === null || _apiData$data === void 0 ? void 0 : _apiData$data[0];
  var offer = offerSet === null || offerSet === void 0 || (_offerSet$shippingOff = offerSet.shippingOffers) === null || _offerSet$shippingOff === void 0 ? void 0 : _offerSet$shippingOff[0];
  if (!offer) return null;
  var arrivalIso = offer.latestArrivalOn;
  if (!arrivalIso) return null;
  var cutoffIso = offer.targetPickupCutoff;
  var address = offerSet === null || offerSet === void 0 ? void 0 : offerSet.address;
  var arrivalLabel = formatArrivalLabel(arrivalIso);
  if (!arrivalLabel) return null;
  var city = (address === null || address === void 0 || (_address$city = address.city) === null || _address$city === void 0 ? void 0 : _address$city.toLowerCase()) || '';
  var zip = (address === null || address === void 0 ? void 0 : address.postalCode) || '';
  return {
    html: "\n      <div class=\"flex items-center gap-1\">\n        Arrives by\n        <span class=\"bg-lime-100 px-1.5\">".concat(arrivalLabel, "</span>\n      </div>\n      <div>\n        Order within\n        <span\n          class=\"font-bold text-lime-900\"\n          data-cutoff-timer\n          data-cutoff-iso=\"").concat(cutoffIso, "\"\n        >\n          ").concat(formatCutoffTime(cutoffIso), "\n        </span>\n        <a href=\"javascript:void(0)\" class=\"delivery-location-toggle inline-flex items-center gap-0.5 cursor-pointer text-cyan-800 capitalize\" data-toggle-zip>\n          ").concat(city, " - ").concat(zip, "\n          <svg class=\"delivery-arrow transition-transform duration-150 [&.is-open]:rotate-180\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\"\n            xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M4 6L8 10L12 6\" stroke=\"#08596D\" stroke-width=\"1.3\" stroke-linecap=\"square\"/>\n          </svg>\n        </a>\n      </div>\n    ")
  };
}
function formatPredictedShippingMessage(apiData) {
  var data = apiData === null || apiData === void 0 ? void 0 : apiData.data;
  if (!data) return null;
  var expiresInSeconds = data.expiresInSeconds,
    friendly = data.friendly,
    date = data.date;

  // If countdown available
  if (expiresInSeconds && expiresInSeconds > 0) {
    return {
      type: 'countdown',
      expiresInSeconds: expiresInSeconds,
      friendly: friendly || null,
      date: date || null
    };
  }

  // Fallback date
  if (date) {
    var shipDate = dayjs_min_default()(date);
    var dateLabel = shipDate.format('dddd, MMM D');
    return {
      type: 'date',
      text: "Order now and we'll ship",
      dateLabel: dateLabel
    };
  }
  return null;
}
;// ./src/js/utils/icons.js
var getAtcSuccessIcon = function getAtcSuccessIcon() {
  return "\n  <svg class=\"w-6 h-6 lg:w-8 lg:h-8\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g clip-path=\"url(#clip0_6781_82116)\">\n      <path d=\"M16.0003 2.66675C8.64033 2.66675 2.66699 8.64008 2.66699 16.0001C2.66699 23.3601 8.64033 29.3334 16.0003 29.3334C23.3603 29.3334 29.3337 23.3601 29.3337 16.0001C29.3337 8.64008 23.3603 2.66675 16.0003 2.66675ZM13.3337 22.6667L6.66699 16.0001L8.54699 14.1201L13.3337 18.8934L23.4537 8.77342L25.3337 10.6667L13.3337 22.6667Z\" fill=\"#4A8500\"/>\n    </g>\n    <defs>\n      <clipPath id=\"clip0_6781_82116\">\n        <rect width=\"32\" height=\"32\" fill=\"white\"/>\n      </clipPath>\n    </defs>\n  </svg>\n";
};
;// ./src/js/bundles/snippets/atc-drawer.ts









var ATC_SECTION_ID = 'add-to-cart-drawer-content';
var getAtcSectionId = function getAtcSectionId() {
  return ATC_SECTION_ID;
};
var renderAtcDrawer = function renderAtcDrawer(renderedSections, addedKey, contextEl) {
  var _window$GlobalDrawer;
  var variantId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (!((_window$GlobalDrawer = window.GlobalDrawer) !== null && _window$GlobalDrawer !== void 0 && _window$GlobalDrawer.loadDrawer) || !renderedSections || !addedKey) return;
  var drawerHtml = renderedSections[getAtcSectionId()];
  if (!drawerHtml) return;
  var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
  var container = doc.querySelector('[data-cart-items]');
  if (!container) return;
  var addedItem = container.querySelector("[data-key=\"".concat(addedKey, "\"]"));
  if (!addedItem) return;
  container.innerHTML = '';
  container.appendChild(addedItem);
  var drawerContent = {
    title: "\n      <span class=\"flex gap-2 items-center\">\n        <span class=\"flex-shrink-0\">".concat(getAtcSuccessIcon(), "</span>\n        Added to cart\n      </span>\n    "),
    content: doc.body.innerHTML
  };
  window.GlobalDrawer.loadDrawer(contextEl, drawerContent, 'wide');
  initAtcShippingMeter();
  window.GlobalDrawer.currentAtcItemKey = addedKey;
  if (variantId) window.GlobalDrawer.currentAtcVariantId = variantId;
  var productId = addedItem.getAttribute('data-product-id');
  renderAtcRecommendations(productId);
  renderAtcShippingMessage();
};
var refreshAtcDrawerContent = function refreshAtcDrawerContent(renderedSections, addedKey) {
  var _addedItem$getAttribu, _addedItem$getAttribu2;
  var addedVariantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var _window = window,
    GlobalDrawer = _window.GlobalDrawer;
  if (!GlobalDrawer || !renderedSections || !addedKey) return;
  var drawerContent = GlobalDrawer.content;
  if (!drawerContent) return;
  var drawerHtml = renderedSections[getAtcSectionId()];
  if (!drawerHtml) return;
  var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');

  // filter only added item
  var container = doc.querySelector('[data-cart-items]');
  if (!container) return;
  var addedItem = container.querySelector("[data-key=\"".concat(addedKey, "\"]"));

  // Fallback: match by variant id
  if (!addedItem && addedVariantId) {
    addedItem = container.querySelector("[data-variant-id=\"".concat(addedVariantId, "\"]"));
  }
  if (!addedItem) return;

  // sync latest key & variant id
  var freshKey = (_addedItem$getAttribu = addedItem.getAttribute('data-key')) !== null && _addedItem$getAttribu !== void 0 ? _addedItem$getAttribu : undefined;
  var freshVariantId = (_addedItem$getAttribu2 = addedItem.getAttribute('data-variant-id')) !== null && _addedItem$getAttribu2 !== void 0 ? _addedItem$getAttribu2 : undefined;
  GlobalDrawer.currentAtcItemKey = freshKey;
  GlobalDrawer.currentAtcVariantId = freshVariantId;
  container.innerHTML = '';
  container.appendChild(addedItem);

  // update only refreshable content
  var newContent = doc.querySelector('[data-content-refresh]');
  var currentContent = drawerContent.querySelector('[data-content-refresh]');
  if (!newContent || !currentContent) return;
  currentContent.innerHTML = newContent.innerHTML;
  initAtcShippingMeter();
};
var initAtcDrawerQtyHandlers = function initAtcDrawerQtyHandlers(drawerContent) {
  if (!drawerContent) return;

  // prevent duplicate binding
  if (drawerContent.dataset.atcQtyBound) return;
  drawerContent.dataset.atcQtyBound = 'true';
  drawerContent.addEventListener('click', handleQtyClick);
  drawerContent.addEventListener('change', handleQtyChange);
  drawerContent.addEventListener('keydown', handleQtyKeydown);
};
var handleQtyClick = function handleQtyClick(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('[data-atc-drawer]')) return;
  var btn = event.target.closest('[data-qty-btn]');
  if (!btn) return;
  var container = btn.closest('[data-qty-container]');
  var input = container === null || container === void 0 ? void 0 : container.querySelector('[data-cart-qty]');
  if (!input) return;
  var isDecrease = btn.dataset.qtyBtn === 'decrease';
  if (isDecrease) {
    if (Number(input.value) <= 1) return;
    input.stepDown();
  } else {
    input.stepUp();
  }
  input.dispatchEvent(new Event('change', {
    bubbles: true
  }));
};
var handleQtyChange = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
    var _container$querySelec;
    var input, quantity, itemKey, itemVariantId, container, btns, elements, sectionId, cartSectionId, isCartPage, sections, response, data, cartSectionMarkup, _window$refreshCartSe, _window2, fsCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (event.target instanceof Element) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          if (event.target.closest('[data-atc-drawer]')) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          input = event.target.closest('[data-cart-qty]');
          if (input) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return");
        case 7:
          quantity = Math.max(1, Number(input.value) || 1);
          itemKey = input.dataset.itemKey;
          itemVariantId = input.dataset.itemVariantId;
          if (itemKey) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return");
        case 12:
          container = input.closest('[data-qty-container]');
          btns = Array.from((_container$querySelec = container === null || container === void 0 ? void 0 : container.querySelectorAll('[data-qty-btn]')) !== null && _container$querySelec !== void 0 ? _container$querySelec : []);
          elements = [input].concat(btns);
          elements.forEach(function (el) {
            el.disabled = true;
            el.classList.add('opacity-50', 'pointer-events-none');
          });
          document.body.style.cursor = 'wait';
          _context.prev = 17;
          sectionId = getAtcSectionId();
          cartSectionId = getCartSectionId();
          isCartPage = window.location.pathname.includes('/cart');
          sections = isCartPage ? [cartSectionId, sectionId] : [sectionId];
          _context.next = 24;
          return cartApi.updateQty(itemKey, quantity, sections);
        case 24:
          response = _context.sent;
          _context.next = 27;
          return response.json();
        case 27:
          data = _context.sent;
          refreshAtcDrawerContent(data === null || data === void 0 ? void 0 : data.sections, itemKey, itemVariantId);
          if (!data) {
            _context.next = 40;
            break;
          }
          if (!isCartPage) {
            _context.next = 37;
            break;
          }
          cartSectionMarkup = data.sections[cartSectionId];
          if (!cartSectionMarkup) {
            _context.next = 35;
            break;
          }
          _context.next = 35;
          return (_window$refreshCartSe = (_window2 = window).refreshCartSection) === null || _window$refreshCartSe === void 0 ? void 0 : _window$refreshCartSe.call(_window2, cartSectionMarkup);
        case 35:
          _context.next = 40;
          break;
        case 37:
          updateCartUI(data === null || data === void 0 ? void 0 : data.item_count);
          fsCode = getFSDiscountInfo(data);
          if (fsCode) {
            updateShippingMeter(data.total_price, fsCode.threshold);
          }
        case 40:
          _context.next = 45;
          break;
        case 42:
          _context.prev = 42;
          _context.t0 = _context["catch"](17);
          console.error('ATC qty update failed:', _context.t0);
        case 45:
          _context.prev = 45;
          elements.forEach(function (el) {
            el.disabled = false;
            el.classList.remove('opacity-50', 'pointer-events-none');
          });
          document.body.style.cursor = '';
          return _context.finish(45);
        case 49:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[17, 42, 45, 49]]);
  }));
  return function handleQtyChange(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var handleQtyKeydown = function handleQtyKeydown(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('[data-atc-drawer]')) return;
  if (!event.target.closest('[data-cart-qty]')) return;
  if (['e', 'E', '+', '-'].includes(event.key)) {
    event.preventDefault();
  }
};
var renderAtcRecommendations = /*#__PURE__*/function () {
  var _ref2 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2(productId) {
    var _window$GlobalDrawer2;
    var drawerContent, currentContainer, sectionId, url, response, html, doc, newContainer;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          drawerContent = (_window$GlobalDrawer2 = window.GlobalDrawer) === null || _window$GlobalDrawer2 === void 0 ? void 0 : _window$GlobalDrawer2.content;
          if (!(!drawerContent || !productId)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          currentContainer = drawerContent.querySelector('[data-atc-recommendations]');
          if (currentContainer) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          sectionId = getAtcSectionId();
          url = "".concat(window.Shopify.routes.root, "recommendations/products?section_id=").concat(sectionId, "&intent=related&product_id=").concat(productId);
          _context2.prev = 8;
          _context2.next = 11;
          return fetch(url);
        case 11:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 14;
            break;
          }
          throw new Error('Failed to fetch recommendations');
        case 14:
          _context2.next = 16;
          return response.text();
        case 16:
          html = _context2.sent;
          doc = new DOMParser().parseFromString(html, 'text/html');
          newContainer = doc.querySelector('[data-atc-recommendations]');
          if (newContainer) {
            _context2.next = 21;
            break;
          }
          return _context2.abrupt("return");
        case 21:
          if (newContainer.innerHTML.trim()) {
            currentContainer.innerHTML = newContainer.innerHTML;
            currentContainer.classList.remove('hidden');
          } else {
            currentContainer.innerHTML = '';
            currentContainer.classList.add('hidden');
          }
          _context2.next = 27;
          break;
        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](8);
          console.error('ATC recommendations failed:', _context2.t0);
        case 27:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[8, 24]]);
  }));
  return function renderAtcRecommendations(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var initAtcRecoHandlers = function initAtcRecoHandlers(drawerContent) {
  if (!drawerContent) return;
  if (drawerContent.dataset.atcRecoBound) return;
  drawerContent.dataset.atcRecoBound = 'true';
  drawerContent.addEventListener('click', handleAtcRecoClick);
};
var handleAtcRecoClick = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
    var btn, variantId, _window$GlobalDrawer3, _window$GlobalDrawer4, sectionId, cartSectionId, isCartPage, sections, data, itemKey, itemVariantId, _data$sections, cartSectionMarkup, _window$refreshCartSe2, _window3, message;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (event.target instanceof Element) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          btn = event.target.closest('[data-atc-reco-add]');
          if (!(!btn || btn.classList.contains('processing'))) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return");
        case 5:
          variantId = btn.dataset.variantId;
          if (variantId) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return");
        case 8:
          // UI state
          btn.classList.add('processing');
          _context3.prev = 9;
          sectionId = getAtcSectionId();
          cartSectionId = getCartSectionId();
          isCartPage = window.location.pathname.includes('/cart');
          sections = isCartPage ? [cartSectionId, sectionId].join(',') : sectionId;
          publishAtcContextFromElement(btn, variantId);
          _context3.next = 17;
          return addItemToCart({
            id: Number(variantId),
            quantity: 1,
            properties: {}
          }, {
            sections: sections,
            sectionsUrl: window.location.pathname
          });
        case 17:
          data = _context3.sent;
          itemKey = (_window$GlobalDrawer3 = window.GlobalDrawer) === null || _window$GlobalDrawer3 === void 0 ? void 0 : _window$GlobalDrawer3.currentAtcItemKey;
          itemVariantId = (_window$GlobalDrawer4 = window.GlobalDrawer) === null || _window$GlobalDrawer4 === void 0 ? void 0 : _window$GlobalDrawer4.currentAtcVariantId; // refresh drawer but keep same item
          refreshAtcDrawerContent(data.sections, itemKey, itemVariantId);
          if (!isCartPage) {
            _context3.next = 28;
            break;
          }
          cartSectionMarkup = (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections[cartSectionId];
          if (!cartSectionMarkup) {
            _context3.next = 26;
            break;
          }
          _context3.next = 26;
          return (_window$refreshCartSe2 = (_window3 = window).refreshCartSection) === null || _window$refreshCartSe2 === void 0 ? void 0 : _window$refreshCartSe2.call(_window3, cartSectionMarkup);
        case 26:
          _context3.next = 30;
          break;
        case 28:
          _context3.next = 30;
          return handleCartMutationSuccess();
        case 30:
          btn.classList.add('atc-success');
          btn.disabled = true;
          _context3.next = 39;
          break;
        case 34:
          _context3.prev = 34;
          _context3.t0 = _context3["catch"](9);
          message = _context3.t0 instanceof Error && _context3.t0.message;
          alert(message || 'Something went wrong');
          console.error('ATC reco add failed:', _context3.t0);
        case 39:
          _context3.prev = 39;
          btn.classList.remove('processing');
          return _context3.finish(39);
        case 42:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[9, 34, 39, 42]]);
  }));
  return function handleAtcRecoClick(_x3) {
    return _ref3.apply(this, arguments);
  };
}()));
var initAtcShippingMeter = function initAtcShippingMeter() {
  var _window$GlobalDrawer5;
  var drawerContent = (_window$GlobalDrawer5 = window.GlobalDrawer) === null || _window$GlobalDrawer5 === void 0 ? void 0 : _window$GlobalDrawer5.content;
  if (!drawerContent) return;
  var meter = drawerContent.querySelector('[data-shipping-meter]');
  if (!meter) return;
  initShippingInfoPopover(meter);
};
var renderAtcShippingMessage = /*#__PURE__*/function () {
  var _ref4 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee4() {
    var _window$GlobalDrawer6;
    var dynamicEl, predictiveData, formatted, messageHTML, totalMinutes, hours, minutes, timeLabel, shipLabel;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dynamicEl = (_window$GlobalDrawer6 = window.GlobalDrawer) === null || _window$GlobalDrawer6 === void 0 ? void 0 : _window$GlobalDrawer6.dynamicContent;
          if (dynamicEl) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return fetchPredictedShippingEstimate();
        case 6:
          predictiveData = _context4.sent;
          formatted = formatPredictedShippingMessage(predictiveData);
          if (formatted) {
            _context4.next = 10;
            break;
          }
          return _context4.abrupt("return");
        case 10:
          messageHTML = ''; // Countdown version
          if (formatted.type === 'countdown' && formatted.expiresInSeconds) {
            totalMinutes = Math.floor(formatted.expiresInSeconds / 60);
            hours = Math.floor(totalMinutes / 60);
            minutes = totalMinutes === 0 && formatted.expiresInSeconds > 0 ? 1 : totalMinutes % 60;
            timeLabel = [hours ? "".concat(hours, " hr").concat(hours > 1 ? 's' : '') : '', minutes ? "".concat(minutes, " min").concat(minutes > 1 ? 's' : '') : ''].filter(Boolean).join(' ');
            shipLabel = formatted.friendly || 'today';
            messageHTML = "\n        If you order within the next <strong>".concat(timeLabel, "</strong> we'll ship <strong>").concat(shipLabel, "!</strong>\n      ");
          }
          // Date version
          else if (formatted.type === 'date' && formatted.dateLabel) {
            messageHTML = "\n        ".concat(formatted.text, " <strong>").concat(formatted.dateLabel, "</strong>.\n      ");
          }
          if (messageHTML) {
            _context4.next = 14;
            break;
          }
          return _context4.abrupt("return");
        case 14:
          dynamicEl.innerHTML = "\n      <div\n        data-atc-shipping-message\n        class=\"px-4 py-1 text-sm text-center lg:text-base bg-nuts-amber-200\"\n      >\n        ".concat(messageHTML, "\n      </div>\n    ");
          dynamicEl.classList.remove('hidden');
          _context4.next = 21;
          break;
        case 18:
          _context4.prev = 18;
          _context4.t0 = _context4["catch"](3);
          console.error('ATC shipping message failed:', _context4.t0);
        case 21:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 18]]);
  }));
  return function renderAtcShippingMessage() {
    return _ref4.apply(this, arguments);
  };
}();
;// ./src/js/lib/analytics/publishWithRetry.ts
var MAX_RETRIES = 10;
var RETRY_DELAY_MS = 50;

/**
 * Publish a custom event to the analytics pixel via `Shopify.analytics.publish`,
 * retrying while the Shopify analytics surface loads. Fire-and-forget — never
 * throws. `caller` prefixes the error log if `publish` throws.
 */
function publishWithRetry(caller, eventName, payload) {
  var attempts = 0;
  var _publish = function publish() {
    var _window$Shopify;
    if ((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.analytics) !== null && _window$Shopify !== void 0 && _window$Shopify.publish) {
      try {
        // Keep the call on its receiver — Shopify's publish may read `this`.
        window.Shopify.analytics.publish(eventName, payload);
      } catch (error) {
        console.error("".concat(caller, ": Shopify.analytics.publish threw"), error);
      }
    } else if (++attempts < MAX_RETRIES) {
      setTimeout(_publish, RETRY_DELAY_MS);
    }
  };
  _publish();
}
;// ./src/js/lib/analytics/publishAtcContext.ts

function publishAtcContext_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function publishAtcContext_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? publishAtcContext_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : publishAtcContext_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/** Wire shape consumed by `nuts-analytics-pixel` (`AtcContext` in `index.ts`). */

/**
 * Publish `nuts:product_added_context` so the analytics pixel can pair
 * attribution (including `page_section`) with the next `product_added_to_cart`.
 * Fire-and-forget — never throws.
 */
function publishAtcContext(payload) {
  var _payload$ts;
  var normalized = publishAtcContext_objectSpread(publishAtcContext_objectSpread({}, payload), {}, {
    variant_id: String(payload.variant_id),
    ts: (_payload$ts = payload.ts) !== null && _payload$ts !== void 0 ? _payload$ts : Date.now()
  });
  publishWithRetry('publishAtcContext', 'nuts:product_added_context', {
    payload: normalized
  });
}

/**
 * Build context from a CTA element's `data-*` attributes. Normalizes the
 * theme's mixed kebab-case / snake_case dataset keys to the wire field names
 * the pixel expects.
 *
 * Accepts `null | undefined` so callers can pass `selectedVariantOption`
 * directly even when it may be null. An absent element is treated as empty
 * dataset — the publish still fires with at least the `variant_id`.
 */
function publishAtcContext_publishAtcContextFromElement(element, variantId) {
  var _element$dataset, _dataset$list_source, _dataset$list_title, _dataset$page_section, _ref, _dataset$product_hand, _dataset$reporting_ca, _dataset$variant_labe;
  var dataset = (_element$dataset = element === null || element === void 0 ? void 0 : element.dataset) !== null && _element$dataset !== void 0 ? _element$dataset : {};
  publishAtcContext({
    variant_id: String(variantId),
    list_source: (_dataset$list_source = dataset.list_source) !== null && _dataset$list_source !== void 0 ? _dataset$list_source : dataset.listSource,
    list_title: (_dataset$list_title = dataset.list_title) !== null && _dataset$list_title !== void 0 ? _dataset$list_title : dataset.listTitle,
    page_section: (_dataset$page_section = dataset.page_section) !== null && _dataset$page_section !== void 0 ? _dataset$page_section : dataset.pageSection,
    position: dataset.position,
    product_handle: (_ref = (_dataset$product_hand = dataset.product_handle) !== null && _dataset$product_hand !== void 0 ? _dataset$product_hand : dataset.productHandle) !== null && _ref !== void 0 ? _ref : dataset.handle,
    reporting_category: (_dataset$reporting_ca = dataset.reporting_category) !== null && _dataset$reporting_ca !== void 0 ? _dataset$reporting_ca : dataset.reportingCategory,
    variant_label: (_dataset$variant_labe = dataset.variant_label) !== null && _dataset$variant_labe !== void 0 ? _dataset$variant_labe : dataset.variantLabel
  });
}
;// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

;// ./src/js/utils/cookie.ts


var getSerializedCookies = function getSerializedCookies() {
  return window.document.cookie;
};

/**
 * By default (`T = string`) the decoded value is returned as-is.
 * To parse a JSON-encoded cookie, supply a type parameter and pass
 * `parseJSON: true`:
 *
 *     parseCookieValue<{ id: number }>(raw, true)
 *
 * The conditional type on `parseJSON` prevents callers from passing
 * `true` when `T` is `string` — `JSON.parse` would fail at runtime
 * for most non-JSON string values.
 *
 * Follows the pattern from nuts/webstore@ff2e543 (`getCookie`).
 */
function getCookie(name, parseJSON) {
  try {
    var cookie = getSerializedCookies().split('; ').find(function (val) {
      return val.startsWith("".concat(name, "="));
    });
    if (cookie) {
      var value = cookie.split('=')[1];
      if (value) {
        var decoded = decodeURIComponent(value);
        // JSON.parse returns `any`, which satisfies T without assertion
        // but we must cast the non-parsed to the caller's generic contract
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return parseJSON ? JSON.parse(decoded) : decoded;
      }
    }
  } catch (_unused) {
    /* invalid cookies count as nonexistent */
  }
  return undefined;
}
var getMaxAge = function getMaxAge(days) {
  return 60 * 60 * 24 * days;
};
var expiresInMonths = function expiresInMonths(months) {
  var avgDaysPerMonth = 30.5;
  return "; max-age=".concat(getMaxAge(avgDaysPerMonth * months));
};
function setCookie(key, value, options) {
  var _options$path, _options$expiresInMon;
  var path = (_options$path = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path !== void 0 ? _options$path : '/';
  var domainAttr = options !== null && options !== void 0 && options.domain ? "; Domain=".concat(options.domain) : '';
  var expiration = isDefined(options === null || options === void 0 ? void 0 : options.expiresInSeconds) ? "; max-age=".concat(options.expiresInSeconds) : expiresInMonths((_options$expiresInMon = options === null || options === void 0 ? void 0 : options.expiresInMonths) !== null && _options$expiresInMon !== void 0 ? _options$expiresInMon : 6);
  var cookieValue = encodeURIComponent(_typeof(value) === 'object' ? JSON.stringify(value) : String(value));
  window.document.cookie = "".concat(key, "=").concat(cookieValue, "; path=").concat(path).concat(domainAttr, "; Secure").concat(expiration);
}

/**
 * Expire a cookie by name. Deletion matches on `(name, domain, path)`, so to
 * remove a specific variant the `domain`/`path` must match how it was written:
 * omit `domain` to delete a host-only cookie, or pass the same `domain` (e.g.
 * `.nuts.com`) to delete a shared-domain cookie.
 */
function deleteCookie(name, options) {
  var _options$path2;
  var path = (_options$path2 = options === null || options === void 0 ? void 0 : options.path) !== null && _options$path2 !== void 0 ? _options$path2 : '/';
  var domainAttr = options !== null && options !== void 0 && options.domain ? "; Domain=".concat(options.domain) : '';
  window.document.cookie = "".concat(name, "=; path=").concat(path).concat(domainAttr, "; max-age=0");
}
;// ./src/js/lib/customizers/analytics.ts

function analytics_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function analytics_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? analytics_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : analytics_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Name of the custom Web Pixel event published by the theme after a successful
 * customizer add-to-cart. Subscribed by `nuts-analytics-pixel` and fanned out
 * to RudderStack as one `Product Added` track per cart line (parent + each
 * selection), each carrying `bundle_id` so the warehouse can re-group.
 */
var CUSTOMIZER_PRODUCT_ADDED_EVENT = 'nuts:customizer_product_added';

/**
 * Attribution context the call-site supplies. The publisher composes this
 * with cart-line data and the `cart` cookie to produce the wire payload.
 */

/**
 * Subset of `CartAddResponseItem` actually consumed by the pixel. Trimming
 * here keeps the cross-boundary payload small (browser → Shopify analytics
 * bus → pixel sandbox) and pins the wire contract — adding/removing a field
 * must happen here and in the pixel's `CustomizerProductAddedItem` together.
 */

/**
 * Wire payload published over `Shopify.analytics.publish`. The pixel-side
 * type lives at
 * `shopify-apps/nuts-analytics-pixel/extensions/nuts-analytics-pixel/src/customizer-product-added.ts`;
 * keep both in sync.
 */

/**
 * Publish a `nuts:customizer_product_added` Web Pixel event after a
 * successful customizer bulk add. Fire-and-forget: never throws, never blocks
 * the caller (the React customizer flow navigates to `/cart` immediately
 * after).
 *
 * Item enumeration is driven by the **customizer state** (parent variant +
 * each filled selection), not by Shopify's `/cart/add.js` response. Shopify
 * collapses some customizer bundles (notably Custom Mix, whose 1oz ingredient
 * variants aren't standalone-purchasable) into a single parent cart line on
 * the storefront, so the response is unreliable as a per-ingredient source
 * of truth. The parent line in the response is still consulted for the
 * bundle correlation properties (`_bundleId`, `_bundleVariantId`) and for
 * discount-aware parent pricing (`final_price`, `final_line_price`).
 *
 * Returns silently when:
 * - Shopify's analytics surface is unavailable (sandbox/opt-out paths).
 * - The response shape is unrecognized (no parent line, no `_bundleId`).
 * - `publish` itself throws.
 */
function publishCustomizerProductAdded(customizer, response, attribution) {
  var _publishEvent = function publishEvent() {
    var _window$Shopify, _parentLine$propertie, _parentLine$propertie2, _window$Shopify2;
    var retries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var publish = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.analytics) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.publish;
    if (typeof publish !== 'function') {
      if (retries > 0) {
        setTimeout(function () {
          return _publishEvent(retries - 1);
        }, 100);
      }
      return;
    }
    if (!Array.isArray(response === null || response === void 0 ? void 0 : response.items) || response.items.length === 0) return;
    var parentLine = response.items.find(function (item) {
      var _item$properties;
      return typeof ((_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._bundleId) === 'string';
    });
    if (!parentLine) return;
    var bundleId = (_parentLine$propertie = parentLine.properties) === null || _parentLine$propertie === void 0 ? void 0 : _parentLine$propertie._bundleId;
    var bundleVariantIdRaw = (_parentLine$propertie2 = parentLine.properties) === null || _parentLine$propertie2 === void 0 ? void 0 : _parentLine$propertie2._bundleVariantId;
    if (typeof bundleId !== 'string' || !bundleId) return;
    var bundleVariantId = Number(bundleVariantIdRaw);
    if (!Number.isFinite(bundleVariantId) || bundleVariantId <= 0) return;
    var cartIdRaw = getCookie('cart');
    var cartId = typeof cartIdRaw === 'string' && cartIdRaw ? cartIdRaw : undefined;
    var payload = analytics_objectSpread(analytics_objectSpread(analytics_objectSpread({
      bundle_id: bundleId,
      bundle_product_id: bundleVariantId
    }, cartId && {
      cart_id: cartId
    }), {}, {
      channel: 'shopify',
      currency: ((_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0 || (_window$Shopify2 = _window$Shopify2.currency) === null || _window$Shopify2 === void 0 ? void 0 : _window$Shopify2.active) || 'USD',
      items: buildWireItems(customizer, parentLine),
      list_source: attribution.list_source
    }, attribution.list_title && {
      list_title: attribution.list_title
    }), {}, {
      page_section: attribution.page_section
    }, attribution.position !== undefined && {
      position: attribution.position
    });
    try {
      publish(CUSTOMIZER_PRODUCT_ADDED_EVENT, payload);
    } catch (error) {
      console.error('publishCustomizerProductAdded: Shopify.analytics.publish threw', error);
    }
  };
  _publishEvent();
}

/**
 * Build the per-line wire items: one parent + one per filled selection.
 * Iterates `customizer.selections` (preserving slot index) rather than
 * `filledSelections` so positional customizers (Trays) resolve the correct
 * slot-aware variant via `getVariantForSelection` — mirrors
 * `buildCartItems`'s iteration semantics.
 */
function buildWireItems(customizer, parentLine) {
  var items = [buildParentItem(customizer, parentLine)];
  customizer.selections.forEach(function (selection, slotIndex) {
    if (!selection) return;
    items.push(buildSelectionItem(customizer, selection, slotIndex));
  });
  return items;
}
function buildParentItem(customizer, parentLine) {
  return {
    // `final_*` come from Shopify so post-discount pricing is correct; the
    // unit `price` is the pre-discount list price from the variant projection.
    final_line_price: parentLine.final_line_price,
    final_price: parentLine.final_price,
    handle: customizer.bundleProduct.handle,
    image: customizer.bundleProduct.listImage,
    price: customizer.selectedVariant.price,
    product_id: customizer.bundleProduct.id,
    product_title: customizer.bundleProduct.name,
    quantity: 1,
    sku: customizer.selectedVariant.sku,
    url: customizer.bundleProduct.url,
    variant_id: customizer.selectedVariant.id,
    variant_title: customizer.selectedVariant.title
  };
}
function buildSelectionItem(customizer, selection, slotIndex) {
  var _customizer$quantityF, _customizer$quantityF2;
  // `getVariantForSelection` honours the customizer's `availabilityFilter`
  // (e.g. resolves the 1oz ingredient variant for a Custom Mix) and uses
  // `slotIndex` for slot-aware variants on positional Tray customizers —
  // exactly what `buildCartItems` does for the cart-line `id`.
  var variant = customizer.getVariantForSelection(selection, slotIndex);
  var quantity = (_customizer$quantityF = (_customizer$quantityF2 = customizer.quantityFromSelection) === null || _customizer$quantityF2 === void 0 ? void 0 : _customizer$quantityF2.call(customizer, selection)) !== null && _customizer$quantityF !== void 0 ? _customizer$quantityF : 1;
  return {
    handle: selection.handle,
    image: selection.listImage,
    price: variant.price,
    product_id: selection.id,
    product_title: selection.name,
    quantity: quantity,
    sku: variant.sku,
    url: selection.url,
    variant_id: variant.id,
    variant_title: variant.title
  };
}
;// ./src/js/lib/customizers/ingredientEvents.ts

/**
 * Semantic build-edit event emitted by customizer mutations. `slotIndex`
 * matters for positional customizers (Tray inner/outer variant resolution).
 */

// Listeners live outside the customizer instance: React flows wrap the
// instance in a valtio proxy, and a Set stored on it would become reactive
// state. The key is whatever object the caller holds (the proxy in React
// flows), which is also `this` inside methods invoked through that proxy —
// so emit and subscribe agree on the key.
var ingredientListeners = new WeakMap();

/**
 * Deliver an ingredient event to the customizer's subscribers, if any.
 * Called by customizer mutation methods after the mutation completes.
 */
function emitIngredientEvent(customizer, type, selection, slotIndex) {
  var listeners = ingredientListeners.get(customizer);
  if (!(listeners !== null && listeners !== void 0 && listeners.size)) return;
  for (var _i = 0, _arr = _toConsumableArray(listeners); _i < _arr.length; _i++) {
    var listener = _arr[_i];
    listener({
      selection: selection,
      slotIndex: slotIndex,
      type: type
    });
  }
}

/**
 * Listen for ingredient add/remove events on one customizer instance.
 * Returns an unsubscribe function.
 */
function subscribeToIngredientEvents(customizer, listener) {
  var listeners = ingredientListeners.get(customizer);
  if (!listeners) {
    listeners = new Set();
    ingredientListeners.set(customizer, listeners);
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- one WeakMap stores listeners for heterogeneous selection types; the per-instance key guarantees the event matches this listener's T
  var stored = listener;
  listeners.add(stored);
  var registered = listeners;
  return function () {
    registered["delete"](stored);
  };
}
;// ./src/js/lib/customizers/variants.ts
/**
 * Get the required variant for a product based on availability filter
 * and an optional refinement predicate.
 *
 * Throws if no matching variant is found, ensuring the return type
 * is never undefined.
 */
function getRequiredVariant(product, availabilityFilter, refinement) {
  var variant = product.variants.find(function (v) {
    var _v$availability, _refinement$match;
    if (!((_v$availability = v.availability) !== null && _v$availability !== void 0 && _v$availability.includes(availabilityFilter))) return false;
    return (_refinement$match = refinement === null || refinement === void 0 ? void 0 : refinement.match(v)) !== null && _refinement$match !== void 0 ? _refinement$match : true;
  });
  if (!variant) {
    var message = "No variant found for product ".concat(product.productKey, " with filter ").concat(availabilityFilter);
    if (refinement) {
      message += " (".concat(refinement.label, ")");
    }
    throw new Error(message);
  }
  return variant;
}
;// ./src/js/lib/customizers/common.ts





function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = common_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function common_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return common_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return common_arrayLikeToArray(o, minLen); }
function common_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function common_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function common_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? common_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : common_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var ENCODING_DELIMITER = '~';
var PARTS_DELIMITER = '*';

// The `_bundle*` line-item property contract. The theme writes these in
// `buildCartItems`; `nuts-cart-transform` reads and merges them, the
// `nuts/webstore` OMS ingests them, and the Shopify-managed order email renders
// them. Coordinate across all four before changing any key. The manifest is the
// exception: only checks inside Shopify read it, and order ingestion does not
// rely on it.
var BUNDLE_ID_KEY = '_bundleId';
/** The parent line's JSON-serialized {@link BundleManifest}. */
var BUNDLE_MANIFEST_KEY = '_bundleManifest';
var BUNDLE_NAME_KEY = '_bundleName';
/** Parts allotted to a Custom Mix child line. Absent on every other bundle. */
var BUNDLE_PARTS_KEY = '_bundleParts';
/**
 * Slot index on Custom Tray child lines, counted across the full slot array so
 * an empty slot leaves a gap rather than shifting the positions after it.
 * Absent on every other bundle.
 */
var BUNDLE_POSITION_KEY = '_bundlePosition';
var BUNDLE_RELATION_CHILD = 'child';
var BUNDLE_RELATION_KEY = '_bundleRelation';
var BUNDLE_RELATION_PARENT = 'parent';
/**
 * The bundle *container's* variant id, written identically onto the parent
 * line and every child line. Matches the line's own variant id on the parent;
 * differs on children. The one marker known to survive when `_bundleRelation`
 * has been stripped (see {@link findBundleParent}).
 */
var BUNDLE_VARIANT_ID_KEY = '_bundleVariantId';
/**
 * Stamped manifests persist in order history, so parsers branch on `version`.
 * Bump it whenever the {@link BundleManifest} shape changes.
 */
var CURRENT_MANIFEST_VERSION = 1;
var CUSTOMIZATIONS_DESCRIPTION_KEY = '_customizationsDescription';

/** A bundle line reduced to just the fields {@link findBundleParent} needs. */

/**
 * Resolve the parent line within a `_bundleId` sibling group.
 *
 * `_bundleRelation === 'parent'` is authoritative when present. Toggling the
 * cart page's gift checkbox once stripped `_bundleRelation` from every line of
 * a group while leaving `_bundleId` and `_bundleVariantId` intact, and orders
 * from that window remain in customer history. So when no line is marked, fall
 * back to the sibling whose own variant id matches `_bundleVariantId` —
 * order-independent, unlike trusting array position. The first sibling is a
 * last-resort default for the case where even `_bundleVariantId` is missing,
 * rather than dropping an ambiguous group entirely.
 */
function findBundleParent(lines) {
  var _lines$find;
  if (lines.length === 0) return undefined;
  var marked = lines.find(function (line) {
    return line.properties[BUNDLE_RELATION_KEY] === BUNDLE_RELATION_PARENT;
  });
  if (marked) return marked;
  var bundleVariantIdRaw = lines.map(function (line) {
    return line.properties[BUNDLE_VARIANT_ID_KEY];
  }).find(function (value) {
    return value !== undefined;
  });
  if (bundleVariantIdRaw === undefined) return lines[0];
  var bundleVariantId = Number(bundleVariantIdRaw);
  return (_lines$find = lines.find(function (line) {
    return line.variantId === bundleVariantId;
  })) !== null && _lines$find !== void 0 ? _lines$find : lines[0];
}

/**
 * Where a list of products would land in a customizer, from
 * {@link BaseCustomizer.planSelections}.
 */

/** A filled selection resolved to what it adds to the cart. */

/**
 * A record of the build stamped on the parent line, and the only record of a
 * component that later vanishes from the cart entirely. It carries what a
 * consumer needs to validate the bundle without the customizer class — a
 * Shopify Function, for instance, cannot expand the `dynamic_bundle`
 * metaobject that would otherwise supply the availability filter.
 */

/**
 * Base class for customizer implementations
 *
 * Provides common pricing, validation, and serialization logic.
 * @template T The type of selections this customizer holds
 */
var BaseCustomizer = /*#__PURE__*/function () {
  function BaseCustomizer(init) {
    var _init$quantity, _init$selections;
    _classCallCheck(this, BaseCustomizer);
    /**
     * Optional display name for the custom build (e.g. Custom Mix trail mix name).
     */
    _defineProperty(this, "selections", []);
    _defineProperty(this, "selectionsArePositional", false);
    this.availabilityFilter = init.availabilityFilter;
    this.bundleProduct = init.bundleProduct;
    this.ingredientLimits = init.ingredientLimits;
    this.name = init.name;
    this.quantity = (_init$quantity = init.quantity) !== null && _init$quantity !== void 0 ? _init$quantity : 1;
    var _init$bundleProduct$v = _slicedToArray(init.bundleProduct.variants, 1);
    this.selectedVariant = _init$bundleProduct$v[0];
    this.selections = (_init$selections = init.selections) !== null && _init$selections !== void 0 ? _init$selections : new Array(this.defaultSelectionLength).fill(undefined);
  }

  /**
   * The base price of the parent product in cents.
   */
  return _createClass(BaseCustomizer, [{
    key: "basePrice",
    get: function get() {
      return this.selectedVariant.price;
    }
  }, {
    key: "baseTotalPrice",
    get: function get() {
      return this.calculateTotal();
    }
  }, {
    key: "canAddToCart",
    get: function get() {
      if (this.filledSelections.length < this.ingredientLimits.min) return false;
      return this.filledSelections.length <= this.ingredientLimits.max;
    }

    /**
     * Default number of selection slots when no explicit selections are provided.
     */
  }, {
    key: "defaultSelectionLength",
    get: function get() {
      return this.selectionsLength();
    }
  }, {
    key: "discountPercentage",
    get: function get() {
      var _this$selectedVariant;
      return (_this$selectedVariant = this.selectedVariant.dynamicBundleDiscountValue) !== null && _this$selectedVariant !== void 0 ? _this$selectedVariant : 0;
    }
  }, {
    key: "effectiveTotalPrice",
    get: function get() {
      return this.calculateTotal(this.discountPercentage > 0);
    }

    /**
     * Selections with empty (undefined) slots removed.
     */
  }, {
    key: "filledSelections",
    get: function get() {
      return this.selections.filter(isDefined_isDefined);
    }
  }, {
    key: "manifest",
    get: function get() {
      var _this = this;
      var _this$ingredientLimit = this.ingredientLimits,
        max = _this$ingredientLimit.max,
        min = _this$ingredientLimit.min;
      var selections = this.selections.flatMap(function (selection, slotIndex) {
        var _this$quantityFromSel, _this$quantityFromSel2;
        if (!selection) return [];
        var variant = _this.getVariantForSelection(selection, slotIndex);
        return common_objectSpread(common_objectSpread(common_objectSpread({
          name: selection.name
        }, isDefined_isDefined(selection.parts) && {
          parts: selection.parts
        }), {}, {
          productKey: selection.productKey,
          quantity: (_this$quantityFromSel = (_this$quantityFromSel2 = _this.quantityFromSelection) === null || _this$quantityFromSel2 === void 0 ? void 0 : _this$quantityFromSel2.call(_this, selection)) !== null && _this$quantityFromSel !== void 0 ? _this$quantityFromSel : 1,
          sku: variant.sku
        }, _this.selectionsArePositional && {
          slot: slotIndex
        }), {}, {
          variantId: variant.id
        });
      });
      return {
        availabilityFilter: this.availabilityFilter,
        // `JSON.stringify()` writes `Infinity` as `null`, so leave it out instead.
        ingredientLimits: common_objectSpread(common_objectSpread({}, Number.isFinite(max) && {
          max: max
        }), {}, {
          min: min
        }),
        selections: selections,
        selectionsArePositional: this.selectionsArePositional,
        type: this.type,
        version: CURRENT_MANIFEST_VERSION
      };
    }

    /**
     * Replace the selections with a plan from {@link planSelections}. Assigned
     * wholesale, like `prefillSelections()`, so no ingredient events are
     * emitted: the customer is starting from a preset, not adding items.
     */
  }, {
    key: "applySelectionPlan",
    value: function applySelectionPlan(plan) {
      this.selections = _toConsumableArray(plan.selections);
    }

    /**
     * Shared slot-write for Box/Bundle/Tray `setSelection`. Compares identity by
     * `productKey`, never by reference (valtio child proxies break reference
     * equality). Public because Alpine's mapped component type drops non-public
     * members.
     */
  }, {
    key: "applySlotSelection",
    value: function applySlotSelection(slot, product) {
      var previous = this.selections[slot];
      if ((previous === null || previous === void 0 ? void 0 : previous.productKey) === (product === null || product === void 0 ? void 0 : product.productKey)) return;
      this.selections[slot] = product;
      if (previous) {
        emitIngredientEvent(this, 'ingredient_removed', previous, slot);
      }
      if (product) {
        emitIngredientEvent(this, 'ingredient_added', product, slot);
      }
    }

    /**
     * Calculate unit price in cents.
     *
     * Sums the prices of all active selections and adds the container's
     * {@link basePrice}. When the customizer is only partially filled
     * (fewer selections than {@link ingredientLimits}.min), the base price
     * is prorated across the filled slots.
     */
  }, {
    key: "calculatePrice",
    value: function calculatePrice() {
      var _this2 = this;
      var applyDiscount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var activeSelections = this.filledSelections;
      var selectionCount = activeSelections.length;
      if (selectionCount === 0) return 0;
      var basePriceByPortion = this.basePrice;
      if (selectionCount < this.ingredientLimits.min) {
        basePriceByPortion = Math.round(this.basePrice / this.ingredientLimits.min * selectionCount);
      }
      var selectionsPrice = this.selections.reduce(function (sum, s, slotIndex) {
        if (!s) return sum;
        if (_this2.selectionPriceModifier) {
          return sum + _this2.selectionPriceModifier(s);
        }
        var variant = _this2.getVariantForSelection(s, slotIndex);
        return sum + variant.price;
      }, 0);
      var price = basePriceByPortion + selectionsPrice;
      if (!applyDiscount || this.discountPercentage <= 0) return price;
      return Math.round(price * (1 - this.discountPercentage / 100));
    }

    /**
     * Calculate total price (price * quantity) in cents.
     */
  }, {
    key: "calculateTotal",
    value: function calculateTotal() {
      var applyDiscount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.calculatePrice(applyDiscount) * this.quantity;
    }
  }, {
    key: "decodeCustomizerSelections",
    value: function decodeCustomizerSelections(options, encodedSelections) {
      if (!encodedSelections) {
        return new Array(this.defaultSelectionLength).fill(undefined);
      }
      var selectionChunks = function selectionChunks(selection) {
        var _selection$split = selection.split(PARTS_DELIMITER),
          _selection$split2 = _slicedToArray(_selection$split, 2),
          id = _selection$split2[0],
          parts = _selection$split2[1];
        return {
          id: Number(id),
          parts: Number(parts) || undefined
        };
      };
      var chunks = encodedSelections.split(ENCODING_DELIMITER).map(selectionChunks);
      var chunkIds = new Set(chunks.map(function (c) {
        return c.id;
      }));
      var productMap = new Map();
      var _iterator = _createForOfIteratorHelper(options),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _product = _step.value;
          var _iterator2 = _createForOfIteratorHelper(_product.variants),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var variant = _step2.value;
              if (chunkIds.has(variant.id)) {
                productMap.set(variant.id, _product);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return Array.from({
        length: this.selectionsLength(chunks.length)
      }, function (_, index) {
        var chunk = chunks[index];
        var product = productMap.get(chunk === null || chunk === void 0 ? void 0 : chunk.id);
        return product && common_objectSpread({
          product: product
        }, chunk);
      });
    }
  }, {
    key: "encodeCustomizerSelections",
    value: function encodeCustomizerSelections() {
      var _this3 = this;
      if (this.filledSelections.length === 0) return '';
      return this.selections.map(function (s, slotIndex) {
        if (!s) return _this3.selectionsArePositional ? '' : undefined;
        var variant = _this3.getVariantForSelection(s, slotIndex);
        return [variant.id, s.parts].filter(isDefined_isDefined).join(PARTS_DELIMITER);
      }).filter(isDefined_isDefined).join(ENCODING_DELIMITER);
    }
  }, {
    key: "getVariantForSelection",
    value: function getVariantForSelection(selection, _slotIndex) {
      return getRequiredVariant(selection, this.availabilityFilter);
    }

    /**
     * Decide where each product would land without changing the customizer.
     * Positional customizers (Tray) keep each product at its index, so a
     * skipped or `undefined` entry leaves that slot empty; the others fill
     * slots in order. Products past {@link selectionsLength} are `overLimit`,
     * and products without a compatible variant for their slot are
     * `incompatible`.
     */
  }, {
    key: "planSelections",
    value: function planSelections(products) {
      var _this4 = this;
      var selections = new Array(this.selectionsLength(products.length)).fill(undefined);
      var skipped = [];
      var nextSlot = 0;
      products.forEach(function (product, index) {
        if (!product) return;
        var slot = _this4.selectionsArePositional ? index : nextSlot;
        if (slot >= selections.length) {
          skipped.push({
            product: product,
            reason: 'overLimit'
          });
          return;
        }
        var selection = _this4.toSelection(product);
        try {
          _this4.getVariantForSelection(selection, slot);
        } catch (_unused) {
          skipped.push({
            product: product,
            reason: 'incompatible'
          });
          return;
        }
        selections[slot] = selection;
        nextSlot += 1;
      });
      return {
        meetsMinimum: selections.filter(isDefined_isDefined).length >= this.ingredientLimits.min,
        selections: selections,
        skipped: skipped
      };
    }
  }, {
    key: "reset",
    value:
    /**
     * Return the build to a fresh customizer's state. Silent, like
     * {@link applySelectionPlan}: it is used when the customer switches views,
     * which changes what they are looking at, not what is in their build.
     */
    function reset() {
      this.name = undefined;
      this.quantity = 1;
      this.selections = new Array(this.defaultSelectionLength).fill(undefined);
    }
  }, {
    key: "selectionsLength",
    value:
    /**
     * Number of selection slots for a build of `requestedCount` products.
     * Uses max for finite limits (e.g. Box=6, Tray=5, Mix=8). When max is
     * Infinity (e.g. Bundle) it grows with the request but never drops below
     * min, to avoid unbounded arrays.
     */
    function selectionsLength() {
      var requestedCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _this$ingredientLimit2 = this.ingredientLimits,
        min = _this$ingredientLimit2.min,
        max = _this$ingredientLimit2.max;
      return max === Infinity ? Math.max(min, requestedCount) : max;
    }
  }]);
}();
;// ./src/js/lib/customizers/cart.ts



function cart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function cart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cart_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cart_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function cart_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = cart_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function cart_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return cart_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cart_arrayLikeToArray(o, minLen); }
function cart_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }


function buildCustomizationsDescription(customizer) {
  var filledSelections = customizer.filledSelections,
    selectionsArePositional = customizer.selectionsArePositional;
  var description;
  if (selectionsArePositional) {
    description = filledSelections.map(function (s) {
      return s.name;
    }).join(', ');
  } else {
    var counts = new Map();
    var _iterator = cart_createForOfIteratorHelper(filledSelections),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _counts$get;
        var selection = _step.value;
        var increment = isDefined_isDefined(selection.parts) ? selection.parts : 1;
        counts.set(selection.name, ((_counts$get = counts.get(selection.name)) !== null && _counts$get !== void 0 ? _counts$get : 0) + increment);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    description = _toConsumableArray(counts).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        count = _ref2[1];
      return "".concat(count, "x ").concat(name);
    }).join(', ');
  }
  if (customizer.name) {
    description = "\"".concat(customizer.name, "\": ").concat(description);
  }
  return description;
}
function buildCartItems(customizer) {
  var bundleId = crypto.randomUUID();
  var parentVariantId = customizer.selectedVariant.id;
  var manifest = customizer.manifest;

  // The child lines are derived from the manifest's selections, so the stamp
  // can never disagree with what is actually added to the cart.
  var items = manifest.selections.map(function (_ref3) {
    var parts = _ref3.parts,
      quantity = _ref3.quantity,
      slot = _ref3.slot,
      variantId = _ref3.variantId;
    return {
      id: variantId,
      quantity: quantity,
      properties: cart_objectSpread(cart_objectSpread(cart_objectSpread(_defineProperty({}, BUNDLE_ID_KEY, bundleId), isDefined_isDefined(parts) && _defineProperty({}, BUNDLE_PARTS_KEY, parts)), isDefined_isDefined(slot) && _defineProperty({}, BUNDLE_POSITION_KEY, slot)), {}, _defineProperty(_defineProperty({}, BUNDLE_RELATION_KEY, BUNDLE_RELATION_CHILD), BUNDLE_VARIANT_ID_KEY, parentVariantId))
    };
  });
  items.unshift({
    id: parentVariantId,
    quantity: 1,
    properties: cart_objectSpread(cart_objectSpread(_defineProperty(_defineProperty({}, BUNDLE_ID_KEY, bundleId), BUNDLE_MANIFEST_KEY, JSON.stringify(manifest)), customizer.name && _defineProperty({}, BUNDLE_NAME_KEY, customizer.name)), {}, _defineProperty(_defineProperty(_defineProperty({}, BUNDLE_RELATION_KEY, BUNDLE_RELATION_PARENT), BUNDLE_VARIANT_ID_KEY, parentVariantId), CUSTOMIZATIONS_DESCRIPTION_KEY, buildCustomizationsDescription(customizer)))
  });
  return items;
}
;// ./src/js/lib/customizers/addCustomizerBundleToCart.ts






/**
 * Single source of truth for the customizer bulk-add-to-cart flow:
 *
 * 1. POSTs `/cart/add.js` with the customizer's selections via
 *    {@link addItemsToCart}.
 * 2. Publishes the `nuts:customizer_product_added` analytics event with the
 *    caller-supplied attribution metadata (fire-and-forget — never blocks or
 *    throws on its own).
 * 3. Returns the raw cart response so the caller can render the ATC drawer,
 *    navigate to `/cart`, etc.
 *
 * Centralising publish here prevents a third caller from forgetting to emit
 * the analytics event — every customizer ATC flow now goes through one path.
 *
 * Caller responsibilities:
 * - Gate on `customizer.canAddToCart` before invoking. This helper does NOT
 *   re-check (the two existing callers handle that differently — throw vs
 *   early-return — and that policy stays at the call-site).
 * - Handle the resolved response (render, navigate, etc.).
 * - Handle cart-API rejections; this helper does not catch them.
 */
function addCustomizerBundleToCart(_x, _x2, _x3) {
  return _addCustomizerBundleToCart.apply(this, arguments);
}
function _addCustomizerBundleToCart() {
  _addCustomizerBundleToCart = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(customizer, attribution, sectionsOptions) {
    var items, response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          items = buildCartItems(customizer); // Shopify stacks lines in add order (last added appears first). Reverse so the
          // parent line is added last and surfaces first in ungrouped views (e.g. emails).
          _context.next = 3;
          return addItemsToCart(_toConsumableArray(items).reverse(), sectionsOptions);
        case 3:
          response = _context.sent;
          publishCustomizerProductAdded(customizer, response, attribution);
          return _context.abrupt("return", response);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _addCustomizerBundleToCart.apply(this, arguments);
}
;// ./src/js/lib/customizers/boxes.ts






function boxes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function boxes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? boxes_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : boxes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

var INGREDIENT_LIMITS = {
  min: 6,
  max: 6
};
var BYOB_PRODUCT_KEY = '3719';
var BYOB_PRODUCT_SKU = '3719-01';
var BoxCustomizer = /*#__PURE__*/function (_BaseCustomizer) {
  function BoxCustomizer(bundleProduct, options) {
    var _this2;
    _classCallCheck(this, BoxCustomizer);
    _this2 = _callSuper(this, BoxCustomizer, [boxes_objectSpread({
      availabilityFilter: BoxCustomizer.availabilityFilter,
      bundleProduct: bundleProduct,
      ingredientLimits: INGREDIENT_LIMITS
    }, options)]);
    _defineProperty(_this2, "type", 'box');
    return _this2;
  }
  _inherits(BoxCustomizer, _BaseCustomizer);
  return _createClass(BoxCustomizer, [{
    key: "prefillSelections",
    value: function prefillSelections() {
      var selections = this.decodeCustomizerSelections.apply(this, arguments);
      this.selections = selections.map(function (s) {
        return s === null || s === void 0 ? void 0 : s.product;
      });
    }
  }, {
    key: "setSelection",
    value: function setSelection(slot, product) {
      if (slot < 0 || slot >= this.ingredientLimits.max) return;
      this.applySlotSelection(slot, product);
    }
  }, {
    key: "toSelection",
    value: function toSelection(product) {
      return product;
    }
  }]);
}(BaseCustomizer);
_defineProperty(BoxCustomizer, "availabilityFilter", 'Build Your Own Box');
_defineProperty(BoxCustomizer, "maxCategoryDepth", 0);
;// ./src/js/lib/customizers/bundles.ts






function bundles_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function bundles_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? bundles_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : bundles_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function bundles_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

/**
 * The first-order discount `nuts-ghsb-discount` gives a Greatest Hits Box, which
 * the builder quotes in place of the parent variant's metafield. It mirrors
 * `FIRST_ORDER_DISCOUNT_PERCENT` in that app's `first-order-discount` function;
 * keep the two in step.
 */
var FIRST_ORDER_DISCOUNT_PERCENT = 20;
var bundles_INGREDIENT_LIMITS = {
  max: Infinity,
  min: 6
};
var BundleCustomizer = /*#__PURE__*/function (_BaseCustomizer) {
  function BundleCustomizer(bundleProduct, options) {
    var _options$firstOrderDi;
    var _this2;
    _classCallCheck(this, BundleCustomizer);
    _this2 = bundles_callSuper(this, BundleCustomizer, [bundles_objectSpread({
      availabilityFilter: BundleCustomizer.availabilityFilter,
      bundleProduct: bundleProduct,
      ingredientLimits: bundles_INGREDIENT_LIMITS
    }, options)]);
    _defineProperty(_this2, "type", 'bundle');
    _this2.firstOrderDiscountWithheld = (_options$firstOrderDi = options === null || options === void 0 ? void 0 : options.firstOrderDiscountWithheld) !== null && _options$firstOrderDi !== void 0 ? _options$firstOrderDi : false;
    return _this2;
  }
  _inherits(BundleCustomizer, _BaseCustomizer);
  return _createClass(BundleCustomizer, [{
    key: "discountPercentage",
    get: function get() {
      return this.firstOrderDiscountWithheld ? 0 : FIRST_ORDER_DISCOUNT_PERCENT;
    }
  }, {
    key: "prefillSelections",
    value: function prefillSelections() {
      var selections = this.decodeCustomizerSelections.apply(this, arguments);
      this.selections = selections.map(function (s) {
        return s === null || s === void 0 ? void 0 : s.product;
      });
    }
  }, {
    key: "setSelection",
    value: function setSelection(slot, product) {
      if (slot < 0) return;

      // Expand selections array if needed
      while (this.selections.length <= slot) {
        this.selections.push(undefined);
      }
      this.applySlotSelection(slot, product);
    }
  }, {
    key: "toSelection",
    value: function toSelection(product) {
      return product;
    }
  }]);
}(BaseCustomizer);
_defineProperty(BundleCustomizer, "availabilityFilter", 'Greatest Hits Box');
;// ./src/js/lib/products/projections.ts
/**
 * The product projection.
 *
 * Must be kept in sync with `snippets/product-projection-data.liquid`.
 */

/**
 * The variant projection.
 *
 * Must be kept in sync with `snippets/product-projection-data.liquid`.
 */

function assertWeightPerCuIn(product) {
  if (!product.weightPerCuIn) throw new Error("Weight per cubic inch is required but missing for product ".concat(product.id));
}
;// ./src/js/utils/math.ts
function math_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = math_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function math_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return math_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return math_arrayLikeToArray(o, minLen); }
function math_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Takes fractional quantities and returns a list of integers  that sum exactly to the target total
 * using the Largest Remainder Method.
 */
function apportionByLargestRemainder(exactValues, targetTotal) {
  var floored = exactValues.map(Math.floor);
  var remainder = targetTotal - sum(floored);
  var fractionalParts = exactValues.map(function (val, i) {
    return {
      frac: val - floored[i],
      i: i
    };
  }).sort(function (a, b) {
    return b.frac - a.frac;
  });
  var _iterator = math_createForOfIteratorHelper(fractionalParts),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var i = _step.value.i;
      if (remainder <= 0) break;
      floored[i] += 1;
      remainder -= 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return floored;
}
function sum(numbers) {
  return numbers.reduce(function (acc, curr) {
    return acc + curr;
  }, 0);
}
/**
 * @example sumBy(items, 'quantity')
 * @example sumBy(items, (item) => item.quantity * item.price)
 */
function sumBy(array, keyOrIteratee) {
  var iteratee = typeof keyOrIteratee === 'function' ? keyOrIteratee : function (entry) {
    return entry[keyOrIteratee];
  };
  return array.reduce(function (acc, entry) {
    return acc + iteratee(entry);
  }, 0);
}
;// ./src/js/lib/products/weight.ts


function weight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function weight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? weight_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : weight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var OUNCES_PER_POUND = 16;
var SUPPORTED_UNITS = ['lb', 'oz'];
function operandValue(operand, unit) {
  if (typeof operand === 'number') return operand;
  if (!unit) throw new Error('Unit is required');
  return Weight.toUnit(operand, unit).value;
}
function ouncesFromPounds(pounds) {
  return pounds * OUNCES_PER_POUND;
}
function poundsFromOunces(ounces) {
  return ounces / OUNCES_PER_POUND;
}
function validateUnit() {
  for (var _len = arguments.length, unitOrWeights = new Array(_len), _key = 0; _key < _len; _key++) {
    unitOrWeights[_key] = arguments[_key];
  }
  unitOrWeights.forEach(function (unitOrWeight) {
    var unit = typeof_typeof(unitOrWeight) === 'object' ? unitOrWeight.unit : unitOrWeight;
    if (!SUPPORTED_UNITS.includes(unit)) throw new Error("Weight unit must be one of: ".concat(SUPPORTED_UNITS.map(function (u) {
      return "`".concat(u, "`");
    }).join(', ')));
  });
}
var Weight = {
  add: function add(a, b) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : a.unit;
    validateUnit(a, unit);
    return {
      unit: unit,
      value: Weight.toUnit(a, unit).value + operandValue(b, unit)
    };
  },
  divide: function divide(a, b) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : a.unit;
    validateUnit(a, unit);
    return Weight.toUnit(weight_objectSpread(weight_objectSpread({}, a), {}, {
      value: a.value / b
    }), unit);
  },
  equals: function equals(a, b) {
    validateUnit(a);
    return a.value === operandValue(b, a.unit);
  },
  from: function from(value, unit) {
    validateUnit(unit);
    return {
      unit: unit,
      value: value
    };
  },
  greaterThan: function greaterThan(a, b) {
    validateUnit(a);
    return a.value > operandValue(b, a.unit);
  },
  greaterThanOrEqual: function greaterThanOrEqual(a, b) {
    validateUnit(a);
    return a.value >= operandValue(b, a.unit);
  },
  lessThan: function lessThan(a, b) {
    validateUnit(a);
    return a.value < operandValue(b, a.unit);
  },
  lessThanOrEqual: function lessThanOrEqual(a, b) {
    validateUnit(a);
    return a.value <= operandValue(b, a.unit);
  },
  multiply: function multiply(a, b) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : a.unit;
    validateUnit(a, unit);
    return Weight.toUnit(weight_objectSpread(weight_objectSpread({}, a), {}, {
      value: a.value * b
    }), unit);
  },
  ratio: function ratio(a, b) {
    validateUnit(a, b);
    return a.value / Weight.toUnit(b, a.unit).value;
  },
  subtract: function subtract(a, b) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : a.unit;
    validateUnit(a, unit);
    return {
      unit: unit,
      value: Weight.toUnit(a, unit).value - operandValue(b, unit)
    };
  },
  sum: function sum(weights) {
    var _weights$;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_weights$ = weights[0]) === null || _weights$ === void 0 ? void 0 : _weights$.unit;
    if (!unit) throw new Error('Unit is required');
    validateUnit(unit);
    var value = sumBy(weights, function (weight) {
      return Weight.toUnit(weight, unit).value;
    });
    return {
      unit: unit,
      value: value
    };
  },
  sumBy: function sumBy(collection, iteratee, unit) {
    var weights = collection.map(iteratee).filter(isDefined_isDefined).map(function (weight) {
      return typeof_typeof(weight) === 'object' ? weight : Weight.from(weight, unit);
    });
    return Weight.sum(weights, unit);
  },
  /**
   * Guarantee that the weight is in the desired unit by converting it if necessary. Grams
   * are currently not supported, as we don't yet have a use case for them.
   */
  toUnit: function toUnit(weight, unit) {
    validateUnit(weight, unit);
    if (weight.unit === unit) return weight;
    return weight.unit === 'lb' ? {
      unit: unit,
      value: ouncesFromPounds(weight.value)
    } : {
      unit: unit,
      value: poundsFromOunces(weight.value)
    };
  }
};
;// ./src/js/lib/customizers/mixes.ts







function mixes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function mixes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? mixes_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mixes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function mixes_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}







var mixes_INGREDIENT_LIMITS = {
  min: 1,
  max: 8
};
var MIX_WHOLESALE_WEIGHT_THRESHOLD = {
  unit: 'lb',
  value: 25
};
var PARTS_LIMIT = 9;
var CUSTOM_MIX_5LB_SKU = '9905-05';
var CUSTOM_MIX_25LB_SKU = '9905-25';
var allocationsCache = new Map();
function validateSelectionVariantByWeight(selection) {
  var _getRequiredVariant = getRequiredVariant(selection, MixCustomizer.availabilityFilter),
    weight = _getRequiredVariant.weight;
  if (!Weight.equals(weight, Weight.from(1, 'oz'))) throw new Error("Failed to find 1oz variant for product ".concat(selection.id));
}
var MixCustomizer = /*#__PURE__*/function (_BaseCustomizer) {
  function MixCustomizer(bundleProduct, options) {
    var _this2;
    _classCallCheck(this, MixCustomizer);
    _this2 = mixes_callSuper(this, MixCustomizer, [mixes_objectSpread({
      availabilityFilter: MixCustomizer.availabilityFilter,
      bundleProduct: bundleProduct,
      ingredientLimits: mixes_INGREDIENT_LIMITS
    }, options)]);
    _defineProperty(_this2, "type", 'mix');
    return _this2;
  }
  _inherits(MixCustomizer, _BaseCustomizer);
  return _createClass(MixCustomizer, [{
    key: "quantityAllocations",
    get: function get() {
      var cacheKey = "".concat(this.encodeCustomizerSelections(), ":").concat(this.selectedVariant.id);
      var cached = allocationsCache.get(cacheKey);
      if (cached) return cached;
      var allocations = this.allocateQuantities();
      allocationsCache.set(cacheKey, allocations);
      return allocations;
    }
  }, {
    key: "weight",
    get: function get() {
      return this.selectedVariant.weight;
    }
  }, {
    key: "allocateQuantities",
    value: function allocateQuantities() {
      var _this3 = this;
      if (!this.filledSelections.length) {
        return new Map();
      }
      var weightProportions = this.calculateWeightProportions();
      var exactQuantities = this.filledSelections.map(function (selection) {
        var _weightProportions$ma;
        validateSelectionVariantByWeight(selection);
        var weightProportion = (_weightProportions$ma = weightProportions.map.get(selection)) !== null && _weightProportions$ma !== void 0 ? _weightProportions$ma : 0;
        var ratio = weightProportion / weightProportions.total;
        return Weight.multiply(_this3.weight, ratio, 'oz').value;
      });
      var finalQuantities = apportionByLargestRemainder(exactQuantities, Weight.toUnit(this.weight, 'oz').value);
      return new Map(this.filledSelections.map(function (s, i) {
        return [s.id, finalQuantities[i]];
      }));
    }

    /**
     * Guarantee that all selection proportions are based on the same weight unit as the selected variant.
     */
  }, {
    key: "calculateWeightProportions",
    value: function calculateWeightProportions() {
      var _this4 = this;
      var tuples = this.filledSelections.map(function (selection) {
        assertWeightPerCuIn(selection);
        var weightPerCuIn = selection.weightPerCuIn,
          parts = selection.parts;
        return [selection, Weight.multiply(weightPerCuIn, parts, _this4.weight.unit).value];
      });
      var total = sumBy(tuples, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          _ = _ref2[0],
          value = _ref2[1];
        return value;
      });
      return {
        map: new Map(tuples),
        total: total
      };
    }
  }, {
    key: "prefillSelections",
    value: function prefillSelections() {
      var selections = this.decodeCustomizerSelections.apply(this, arguments);
      this.selections = selections.map(function (s) {
        if (!(s !== null && s !== void 0 && s.parts)) return undefined;
        return mixes_objectSpread(mixes_objectSpread({}, s.product), {}, {
          parts: s.parts
        });
      });
    }
  }, {
    key: "quantityFromSelection",
    value: function quantityFromSelection(selection) {
      var _this$quantityAllocat;
      return (_this$quantityAllocat = this.quantityAllocations.get(selection.id)) !== null && _this$quantityAllocat !== void 0 ? _this$quantityAllocat : 0;
    }
  }, {
    key: "selectionPriceModifier",
    value: function selectionPriceModifier(selection) {
      var variant = getRequiredVariant(selection, this.availabilityFilter);
      return this.quantityFromSelection(selection) * variant.price;
    }
  }, {
    key: "setSelection",
    value: function setSelection(product, parts) {
      var slot = this.selections.findIndex(function (s) {
        return (s === null || s === void 0 ? void 0 : s.productKey) === product.productKey;
      });
      if (parts <= 0) {
        if (slot >= 0) {
          var previous = this.selections[slot];
          this.selections[slot] = undefined;
          if (previous) {
            emitIngredientEvent(this, 'ingredient_removed', previous, slot);
          }
        }
        return;
      }
      if (parts > PARTS_LIMIT) {
        throw new Error("Maximum of ".concat(PARTS_LIMIT, " parts per ingredient"));
      }
      if (slot >= 0) {
        // Parts change on an existing ingredient — not an add/remove.
        this.selections[slot] = mixes_objectSpread(mixes_objectSpread({}, product), {}, {
          parts: parts
        });
        return;
      }
      var filledCount = this.selections.filter(isDefined_isDefined).length;
      if (filledCount >= this.ingredientLimits.max) {
        throw new Error("You've reached the max of ".concat(this.ingredientLimits.max, " ingredients"));
      }
      var selection = mixes_objectSpread(mixes_objectSpread({}, product), {}, {
        parts: parts
      });
      var emptySlot = this.selections.findIndex(function (s) {
        return !s;
      });
      if (emptySlot >= 0) {
        this.selections[emptySlot] = selection;
        emitIngredientEvent(this, 'ingredient_added', selection, emptySlot);
      } else {
        this.selections.push(selection);
        emitIngredientEvent(this, 'ingredient_added', selection, this.selections.length - 1);
      }
    }
  }, {
    key: "toSelection",
    value: function toSelection(product) {
      return mixes_objectSpread(mixes_objectSpread({}, product), {}, {
        parts: 1
      });
    }
  }]);
}(BaseCustomizer);
_defineProperty(MixCustomizer, "availabilityFilter", 'Custom Mix');
_defineProperty(MixCustomizer, "maxCategoryDepth", 1);
;// ./src/js/lib/customizers/trays.ts






function trays_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function trays_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? trays_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : trays_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function trays_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}


var LARGE_CUSTOM_TRAY_PRODUCT_KEY = '9901';
var MEDIUM_CUSTOM_TRAY_PRODUCT_KEY = '9900';
var LARGE_CUSTOM_TRAY_SKU = "".concat(LARGE_CUSTOM_TRAY_PRODUCT_KEY, "-05");
var MEDIUM_CUSTOM_TRAY_SKU = "".concat(MEDIUM_CUSTOM_TRAY_PRODUCT_KEY, "-03");
var trays_INGREDIENT_LIMITS = {
  min: 5,
  max: 5
};
var TrayCustomizer = /*#__PURE__*/function (_BaseCustomizer) {
  function TrayCustomizer(bundleProduct, options) {
    var _this2;
    _classCallCheck(this, TrayCustomizer);
    _this2 = trays_callSuper(this, TrayCustomizer, [trays_objectSpread({
      availabilityFilter: TrayCustomizer.availabilityFilter,
      bundleProduct: bundleProduct,
      ingredientLimits: trays_INGREDIENT_LIMITS
    }, options)]);
    _defineProperty(_this2, "selectionsArePositional", true);
    _defineProperty(_this2, "type", 'tray');
    return _this2;
  }
  _inherits(TrayCustomizer, _BaseCustomizer);
  return _createClass(TrayCustomizer, [{
    key: "innerSlotIndex",
    get: function get() {
      return this.ingredientLimits.max - 1;
    }
  }, {
    key: "getVariantForSelection",
    value: function getVariantForSelection(selection, slotIndex) {
      var bundleVariantId = this.selectedVariant.id;
      var position = slotIndex === this.innerSlotIndex ? 'inner' : 'outer';
      return getRequiredVariant(selection, this.availabilityFilter, {
        match: function match(v) {
          return v.forBundleVariants.includes(bundleVariantId) && v.title.toLowerCase().includes(position);
        },
        label: "forBundleVariant ".concat(bundleVariantId, ", position \"").concat(position, "\"")
      });
    }
  }, {
    key: "prefillSelections",
    value: function prefillSelections() {
      var selections = this.decodeCustomizerSelections.apply(this, arguments);
      this.selections = selections.map(function (s) {
        return s === null || s === void 0 ? void 0 : s.product;
      });
    }
  }, {
    key: "reorderSelections",
    value: function reorderSelections(fromIndex, toIndex) {
      if (fromIndex === toIndex || fromIndex < 0 || fromIndex >= this.selections.length || toIndex < 0 || toIndex >= this.selections.length) return;
      var temp = this.selections[fromIndex];
      this.selections[fromIndex] = this.selections[toIndex];
      this.selections[toIndex] = temp;
    }
  }, {
    key: "setSelection",
    value: function setSelection(slot, product) {
      if (slot < 0 || slot >= this.ingredientLimits.max) return;
      this.applySlotSelection(slot, product);
    }
  }, {
    key: "toSelection",
    value: function toSelection(product) {
      return product;
    }
  }]);
}(BaseCustomizer);
_defineProperty(TrayCustomizer, "availabilityFilter", 'Custom Tray');
;// ./src/js/utils/cart.ts
/** Free-shipping tier as authored in the section settings. */

var cart_getCartSectionId = function getCartSectionId() {
  var _document$querySelect;
  return ((_document$querySelect = document.querySelector('[data-cart-page-section]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('data-cart-page-section')) || 'cart-page';
};
var compileCopy = function compileCopy(copy) {
  var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return copy.replace(/\[(amount-left)\]/gi, function (_, litral) {
    var _vars$litral$toLowerC;
    return (_vars$litral$toLowerC = vars === null || vars === void 0 ? void 0 : vars[litral === null || litral === void 0 ? void 0 : litral.toLowerCase()]) !== null && _vars$litral$toLowerC !== void 0 ? _vars$litral$toLowerC : litral;
  });
};
var getTierProgress = function getTierProgress(_ref) {
  var tiers = _ref.tiers,
    spentAmount = _ref.spentAmount,
    index = _ref.index;
  var props = {
    progress: 0,
    isQualified: false,
    isCurrent: false
  };
  var threshold = tiers[index]['threshold-amount'];
  var baseDiff = spentAmount / threshold * 100;
  var match = baseDiff <= 100;
  if (match) {
    var diff;
    if (!index) diff = baseDiff;else {
      var previousThreshold = tiers[index - 1]['threshold-amount'];
      var currentBase = spentAmount - previousThreshold;
      var compareAgainst = threshold - previousThreshold;
      diff = currentBase / compareAgainst * 100;
    }
    props.progress = Math.max(0, diff);
    if (props.progress === 100) props.isQualified = true;
  } else {
    props.progress = 100;
    props.isQualified = true;
  }
  if (!props.isQualified) {
    var _tiers;
    if (!index) props.isCurrent = true;else if (tiers !== null && tiers !== void 0 && (_tiers = tiers[index - 1]) !== null && _tiers !== void 0 && _tiers.isQualified) {
      props.isCurrent = true;
    }
  }
  return props;
};
var cart_getFSDiscountInfo = function getFSDiscountInfo() {
  var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var discountCodes = cart.discount_codes || [];
  if (!discountCodes.length) return null;
  var fsCode = discountCodes.find(function (_ref2) {
    var code = _ref2.code,
      applicable = _ref2.applicable;
    return applicable === true && typeof code === 'string' && /FS\d+/.test(code);
  });
  if (!fsCode) return null;
  var match = fsCode.code.match(/FS(\d+)/);
  if (!match) return null;
  var threshold = parseInt(match[1], 10);
  return {
    code: fsCode.code,
    threshold: threshold
  };
};
;// ./src/js/utils/cart-api.ts









function cart_api_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function cart_api_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cart_api_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cart_api_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function cart_api_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}


/** Carries the failing cart action so handlers can tell the flows apart. */
var CartApiError = /*#__PURE__*/function (_Error) {
  function CartApiError(message, action) {
    var _this2;
    _classCallCheck(this, CartApiError);
    _this2 = cart_api_callSuper(this, CartApiError, [message]);
    _this2.action = action;
    return _this2;
  }
  _inherits(CartApiError, _Error);
  return _createClass(CartApiError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var apiCall = /*#__PURE__*/function () {
  var _ref = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee(endpoint) {
    var method,
      payload,
      msgConfig,
      response,
      errorData,
      _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          method = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'POST';
          payload = _args.length > 2 ? _args[2] : undefined;
          msgConfig = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
          _context.prev = 3;
          _context.next = 6;
          return fetch(endpoint, {
            method: method,
            headers: {
              'Content-Type': 'application/json'
            },
            body: payload ? JSON.stringify(payload) : null
          });
        case 6:
          response = _context.sent;
          if (response.ok) {
            _context.next = 12;
            break;
          }
          _context.next = 10;
          return response.json();
        case 10:
          errorData = _context.sent;
          throw new CartApiError(errorData.message || msgConfig.error || 'Something went wrong', msgConfig.action);
        case 12:
          return _context.abrupt("return", response);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](3);
          alert("Sorry, we couldn't complete that.");
          console.error('Cart API Error:', {
            message: _context.t0 instanceof Error ? _context.t0.message : undefined,
            action: _context.t0 instanceof CartApiError ? _context.t0.action : undefined,
            error: _context.t0
          });
          throw _context.t0;
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 15]]);
  }));
  return function apiCall(_x) {
    return _ref.apply(this, arguments);
  };
}();
var cart_api_cartApi = {
  updateQty: function updateQty(itemKey, quantity) {
    var sections = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var sectionsUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.location.pathname;
    var payload = cart_api_objectSpread(cart_api_objectSpread({
      id: String(itemKey),
      quantity: quantity
    }, sections && {
      sections: sections
    }), sectionsUrl && sections && {
      sections_url: sectionsUrl
    });
    var msgConfig = {
      action: 'updateQty',
      error: 'An error occurred while updating the cart.'
    };
    return apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },
  addToCart: function addToCart(variantId) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var properties = arguments.length > 2 ? arguments[2] : undefined;
    var sections = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var sectionsUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.pathname;
    var payload = cart_api_objectSpread(cart_api_objectSpread(cart_api_objectSpread({
      id: String(variantId),
      quantity: quantity
    }, properties && Object.keys(properties).length > 0 ? {
      properties: properties
    } : {}), sections && {
      sections: sections
    }), sectionsUrl && sections && {
      sections_url: sectionsUrl
    });
    return apiCall('/cart/add.js', 'POST', payload);
  },
  addFreeGift: function addFreeGift(freeGiftVariantId) {
    var payload = {
      items: [{
        id: String(freeGiftVariantId),
        quantity: 1,
        properties: {
          _is_free_gift: 'true'
        }
      }]
    };
    var msgConfig = {
      action: 'addFreeGift',
      error: 'An error occurred while adding the free gift.'
    };
    return apiCall('/cart/add.js', 'POST', payload, msgConfig);
  },
  removeFreeGift: function removeFreeGift(lineItems) {
    var _lineItems$find;
    var freeGiftItemKey = (_lineItems$find = lineItems.find(function (item) {
      return item.properties && item.properties._is_free_gift === 'true';
    })) === null || _lineItems$find === void 0 ? void 0 : _lineItems$find.key;
    if (!freeGiftItemKey) return;
    var payload = {
      id: String(freeGiftItemKey),
      quantity: 0
    };
    var msgConfig = {
      action: 'removeFreeGift',
      error: 'An error occurred while removing the free gift.'
    };
    apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },
  updateSellingPlan: function updateSellingPlan(sellingPlanId, itemKey, quantity) {
    var sections = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var sectionsUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.pathname;
    var payload = cart_api_objectSpread(cart_api_objectSpread({
      id: String(itemKey),
      quantity: quantity,
      selling_plan: sellingPlanId
    }, sections && {
      sections: sections
    }), sectionsUrl && sections && {
      sections_url: sectionsUrl
    });
    var msgConfig = {
      action: 'updateSellingPlan',
      error: 'An error occurred while updating the selling plan.'
    };
    return apiCall('/cart/change.js', 'POST', payload, msgConfig);
  },
  updateLineItemProperties: function updateLineItemProperties(lineIndex, quantity, properties) {
    var setLoading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return undefined;
    };
    setLoading({
      status: true,
      lineIndex: lineIndex,
      action: 'updateProperties'
    });
    // Use 'line' (1-based index) instead of 'id' for property updates
    var payload = {
      line: lineIndex,
      quantity: quantity,
      properties: properties
    };
    var msgConfig = {
      action: 'updateLineItemProperties',
      error: 'An error occurred while updating the item.'
    };
    return apiCall('/cart/change.js', 'POST', payload, msgConfig)["finally"](function () {
      setLoading(null);
    });
  }
};
var fetchCart = /*#__PURE__*/function () {
  var _ref2 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee2() {
    var response;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch('/cart.js', {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          });
        case 2:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 5;
            break;
          }
          throw new Error('Failed to fetch cart');
        case 5:
          return _context2.abrupt("return", response.json());
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchCart() {
    return _ref2.apply(this, arguments);
  };
}();
var cart_api_updateCartUI = function updateCartUI(cartCount) {
  var countEl = document.getElementById('cart-item-count');
  if (countEl) {
    countEl.textContent = String(cartCount);
  }
};

// Webpack inlines this module into every entry bundle, so a module-level
// variable would give each bundle its own dedupe state. Keep it page-global.
var SIGNATURE_KEY = '__nutsLastSyncedCartSignature';
var getLastSyncedSignature = function getLastSyncedSignature() {
  var _window$SIGNATURE_KEY;
  return (_window$SIGNATURE_KEY = window[SIGNATURE_KEY]) !== null && _window$SIGNATURE_KEY !== void 0 ? _window$SIGNATURE_KEY : null;
};
var setLastSyncedSignature = function setLastSyncedSignature(signature) {
  window[SIGNATURE_KEY] = signature;
};
var cartSignature = function cartSignature(cart) {
  return [cart.item_count, cart.total_price].concat(_toConsumableArray((cart.items || []).map(function (item) {
    return "".concat(item.key, ":").concat(item.quantity);
  }))).join('|');
};
var dispatchCartUpdated = function dispatchCartUpdated(cart) {
  if (!cart) {
    console.error('[cart-events] dispatchCartUpdated called without cart');
    return;
  }

  // Flows that dispatch directly (e.g. the cart page) count as a sync too, so
  // the fetch-interceptor's follow-up refresh doesn't fire cart:updated again.
  setLastSyncedSignature(cartSignature(cart));
  document.dispatchEvent(new CustomEvent('cart:updated', {
    detail: {
      cart: cart
    }
  }));
};
var syncCartUIFromCart = function syncCartUIFromCart(cart) {
  if (!cart) return;
  if (cartSignature(cart) === getLastSyncedSignature()) return;
  var fsCode = cart_getFSDiscountInfo(cart);
  if (fsCode) {
    shipping_meter_updateShippingMeter(cart.total_price, fsCode.threshold);
  }
  dispatchCartUpdated(cart);
  cart_api_updateCartUI(cart.item_count);
};
var cart_api_handleCartMutationSuccess = /*#__PURE__*/function () {
  var _ref3 = asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee3() {
    var cart;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetchCart();
        case 3:
          cart = _context3.sent;
          if (cart) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
          syncCartUIFromCart(cart);
          return _context3.abrupt("return", cart);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          console.error('Cart sync failed:', _context3.t0);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 10]]);
  }));
  return function handleCartMutationSuccess() {
    return _ref3.apply(this, arguments);
  };
}();
;// ./src/js/bundles/sections/customizer-recommendations.ts











function customizer_recommendations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function customizer_recommendations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? customizer_recommendations_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : customizer_recommendations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function customizer_recommendations_callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/**
 * Section bundle: Customizer Recommendations
 *
 * This is the section-scoped entry point. It runs independently of the theme
 * bundle so its imports (customizer classes, cart API, Alpine reactive
 * instances) don't weigh on every page of the site.
 *
 * Skeleton implementation — the Alpine data bindings, intent handler
 * registrations, and cart wiring are fleshed out in a later commit.
 */












/**
 * Per-card entry inside {@link CustomizerRecommendationsData.cards}.
 *
 * Must be kept in sync with the `section_data` capture in
 * `src/liquid/sections/customizer-recommendations.liquid`.
 */

/**
 * Shape of the JSON payload emitted by the section's
 * `<script type="application/json" data-type="customizer-recommendations-data">`
 * tag. Each script tag carries a `data-section-id` attribute identifying the
 * owning section — merchandisers may place more than one instance of this
 * section on a page, so consumers must iterate over every matching tag rather
 * than assuming a single payload.
 *
 * Must be kept in sync with the `section_data` capture in
 * `src/liquid/sections/customizer-recommendations.liquid`.
 */

var customizersByAvailabilityKey = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BoxCustomizer.availabilityFilter, BoxCustomizer), BundleCustomizer.availabilityFilter, BundleCustomizer), MixCustomizer.availabilityFilter, MixCustomizer), TrayCustomizer.availabilityFilter, TrayCustomizer);
function isMixCustomizer(customizer) {
  return (customizer === null || customizer === void 0 ? void 0 : customizer.type) === 'mix';
}
var sectionsById = new Map();
var CustomizerRecommendationsStartupError = /*#__PURE__*/function (_Error) {
  function CustomizerRecommendationsStartupError(message, cause) {
    var _this2;
    _classCallCheck(this, CustomizerRecommendationsStartupError);
    _this2 = customizer_recommendations_callSuper(this, CustomizerRecommendationsStartupError, [message]);
    _this2.name = 'CustomizerRecommendationsStartupError';
    _this2.cause = cause;
    return _this2;
  }
  _inherits(CustomizerRecommendationsStartupError, _Error);
  return _createClass(CustomizerRecommendationsStartupError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var CustomizerCardStartupError = /*#__PURE__*/function (_Error2) {
  function CustomizerCardStartupError(message) {
    var _this3;
    _classCallCheck(this, CustomizerCardStartupError);
    _this3 = customizer_recommendations_callSuper(this, CustomizerCardStartupError, [message]);
    _this3.name = 'CustomizerCardStartupError';
    return _this3;
  }
  _inherits(CustomizerCardStartupError, _Error2);
  return _createClass(CustomizerCardStartupError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var alpineInitialized = false;
var queuedStartupErrors = [];
var queueFlushInitialized = false;
function handleStartupError(message, cause) {
  var error = new CustomizerRecommendationsStartupError(message, cause);
  console.error(error);
  if (document.readyState === 'complete') {
    window.dispatchEvent(new CustomEvent('customizer-recommendations-startup-error', {
      detail: {
        message: message
      }
    }));
  } else {
    queuedStartupErrors.push(error);
    if (!queueFlushInitialized) {
      queueFlushInitialized = true;
      var flushQueue = function flushQueue() {
        queuedStartupErrors.forEach(function (error) {
          window.dispatchEvent(new CustomEvent('customizer-recommendations-startup-error', {
            detail: {
              message: error.message
            }
          }));
        });
        queuedStartupErrors.length = 0;
        queueFlushInitialized = false;
      };
      if (alpineInitialized) {
        flushQueue();
      } else {
        document.addEventListener('alpine:initialized', function () {
          alpineInitialized = true;
          flushQueue();
        });
      }
    }
  }
}
function sectionStartup() {
  var sectionData = document.querySelectorAll('script[data-type="customizer-recommendations-data"]');
  sectionData.forEach(function (script) {
    var sectionId = script.getAttribute('data-section-id');
    if (!sectionId) return handleStartupError('Script tag is missing required section ID');
    var data;
    try {
      data = JSON.parse(script.textContent);
      if (!data.availabilityFilter) {
        return handleStartupError('Either a Dynamic Bundle has not been selected or the selected entry is missing an "availability_filter" setting');
      }
      if (!data.cards) {
        return handleStartupError('Section appears empty');
      }
      if (Object.values(data.cards).some(function (c) {
        return typeof_typeof(c) !== 'object';
      })) {
        return handleStartupError('There was an issue with some of the product cards');
      }
      if (!data.parentProductProjection) {
        return handleStartupError('There was an issue loading the main Dynamic Bundle product');
      }
      sectionsById.set(sectionId, data);
    } catch (error) {
      return handleStartupError('Failed to parse customizer-recommendations-data', error);
    }
  });
}
var registerCustomizerRecommendationsCard = function registerCustomizerRecommendationsCard() {
  window.Alpine.data('customizerRecommendationsCard', function (_ref) {
    var blockId = _ref.blockId,
      _ref$customizeUrl = _ref.customizeUrl,
      customizeUrl = _ref$customizeUrl === void 0 ? '' : _ref$customizeUrl,
      debug = _ref.debug,
      sectionId = _ref.sectionId;
    return {
      blockId: blockId,
      customizeUrl: customizeUrl,
      customizer: undefined,
      customizerUrlSearchParams: '',
      designModeErrorMessages: [],
      listTitle: '',
      prepackagedProjection: undefined,
      sectionId: sectionId,
      addToCart: function addToCart() {
        var _this4 = this;
        return asyncToGenerator_asyncToGenerator(/*#__PURE__*/regenerator_default().mark(function _callee() {
          var sectionsOptions, _this4$prepackagedPro, variant, response, _response;
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (_this4.canAddToCart) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                sectionsOptions = {
                  sections: ATC_SECTION_ID,
                  sectionsUrl: window.location.pathname
                };
                if (!_this4.prepackagedProjection) {
                  _context.next = 14;
                  break;
                }
                _this4$prepackagedPro = _slicedToArray(_this4.prepackagedProjection.variants, 1), variant = _this4$prepackagedPro[0];
                if (variant) {
                  _context.next = 7;
                  break;
                }
                throw new Error('Prepackaged product has no available variant');
              case 7:
                publishAtcContext(customizer_recommendations_objectSpread(customizer_recommendations_objectSpread({
                  list_source: 'customizer_recommendations'
                }, _this4.listTitle ? {
                  list_title: _this4.listTitle
                } : {}), {}, {
                  page_section: 'Product Recommendations',
                  variant_id: String(variant.id)
                }));
                _context.next = 10;
                return cart_addItemToCart({
                  id: variant.id,
                  quantity: 1,
                  properties: {}
                }, sectionsOptions);
              case 10:
                response = _context.sent;
                renderAtcDrawer(response.sections, response.key, _this4.$root);
                _context.next = 22;
                break;
              case 14:
                if (!_this4.customizer) {
                  _context.next = 21;
                  break;
                }
                _context.next = 17;
                return addCustomizerBundleToCart(_this4.customizer, customizer_recommendations_objectSpread(customizer_recommendations_objectSpread({
                  list_source: 'customizer_recommendations'
                }, _this4.listTitle && {
                  list_title: _this4.listTitle
                }), {}, {
                  page_section: 'Product Recommendations'
                }), sectionsOptions);
              case 17:
                _response = _context.sent;
                renderAtcDrawer(_response.sections, _response.items[0].key, _this4.$root);
                _context.next = 22;
                break;
              case 21:
                throw new Error('Card has neither a prepackaged product nor a customizer');
              case 22:
                _context.next = 24;
                return cart_api_handleCartMutationSuccess();
              case 24:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      get canAddToCart() {
        var _ref2, _this$customizer;
        return (_ref2 = isDefined_isDefined(this.prepackagedProjection) || ((_this$customizer = this.customizer) === null || _this$customizer === void 0 ? void 0 : _this$customizer.canAddToCart)) !== null && _ref2 !== void 0 ? _ref2 : false;
      },
      get canCustomize() {
        return this.customizeUrl.length > 0 && this.customizerUrlSearchParams.length > 0;
      },
      init: function init() {
        var _this5 = this,
          _sectionData$sectionT;
        var handleInitError = function handleInitError(merchantFacingMessage, devDetails) {
          _this5.designModeErrorMessages.push(merchantFacingMessage);
          if (devDetails) {
            console.error(new CustomizerCardStartupError(devDetails));
          }
        };
        var badSectionDataErrorMessage = 'There was an issue initializing this section. Please check the console for more details';
        var sectionData = sectionsById.get(sectionId);
        if (!sectionData) {
          return handleInitError(badSectionDataErrorMessage, "Script tag is missing required section ID: ".concat(sectionId));
        }
        var availabilityFilter = sectionData.availabilityFilter,
          parentProductProjection = sectionData.parentProductProjection;
        var Customizer = customizersByAvailabilityKey[availabilityFilter];
        this.listTitle = (_sectionData$sectionT = sectionData.sectionTitle) !== null && _sectionData$sectionT !== void 0 ? _sectionData$sectionT : '';
        var cardData = sectionData.cards[blockId];
        this.prepackagedProjection = cardData.prepackagedProjection;
        var hasPrepackaged = isDefined_isDefined(this.prepackagedProjection);

        // Section-level config issues are fatal for every card regardless
        // of whether a prepackaged product is present.
        if (!Customizer || !parentProductProjection) {
          if (debug) {
            debugLog('customizer %o', Customizer);
            debugLog('parentProductProjection %o', parentProductProjection);
            debugLog('cardData %o', cardData);
          }
          var details = [];
          if (!Customizer) details.push('customizer class not found');
          if (!parentProductProjection) details.push('parentProductProjection not found');
          var identifier = cardData.name || cardData.blockId;
          var devDetails = "".concat(identifier, ": ").concat(details.join('; '));
          return handleInitError(badSectionDataErrorMessage, devDetails);
        }

        // No products to seed the customizer with.
        // - If a prepackaged product is set, this is a valid "prepackaged-only"
        //   card: skip dynamic-bundle hydration and fall through to intent
        //   registration so the Add to cart button works.
        // - Otherwise the card is genuinely misconfigured.
        if (!cardData.products.length) {
          if (!hasPrepackaged) {
            if (debug) {
              debugLog('cardData %o', cardData);
            }
            var _identifier = cardData.name || cardData.blockId;
            return handleInitError('Either no products have been selected or all selected products are incompatible with the selected bundle', "".concat(_identifier, ": products array is empty"));
          }
        } else {
          var _this$customizer2, _this$customizer4;
          this.customizer = new Customizer(parentProductProjection);
          if (debug) {
            debugLog('customizer %o', this.customizer);
          }
          cardData.products.forEach(function (product, i) {
            try {
              var _this5$customizer;
              // sanity check every card product; customizer will throw if any are invalid
              (_this5$customizer = _this5.customizer) === null || _this5$customizer === void 0 || _this5$customizer.getVariantForSelection(product, i);

              // safe to add to the customizer's selections, but the signature differs for Custom Mix
              if (isMixCustomizer(_this5.customizer)) {
                var parts = 1;
                _this5.customizer.setSelection(product, parts);
              } else {
                var _this5$customizer2;
                (_this5$customizer2 = _this5.customizer) === null || _this5$customizer2 === void 0 || _this5$customizer2.setSelection(i, product);
              }
            } catch (_unused) {
              var ancestorOrigins = window.location.ancestorOrigins;
              var adminOrigin = ancestorOrigins && ancestorOrigins.length > 0 ? ancestorOrigins[ancestorOrigins.length - 1] : window.location.href;
              var productAdminUrl = new URL("/admin/products/".concat(product.id), adminOrigin);
              var adminLink = "<a href=\"".concat(productAdminUrl.href, "\" target=\"_blank\">").concat(product.name, "</a>");
              var message = "<strong class=\"font-semibold underline font-sofia-pro\">".concat(adminLink, "</strong> is either out of stock, marked as unavailable, or lacks a variant compatible with the selected bundle");
              handleInitError(message);
            }
          });
          var encodedSelections = (_this$customizer2 = this.customizer) === null || _this$customizer2 === void 0 ? void 0 : _this$customizer2.encodeCustomizerSelections();
          // Only stamp `selections` when the combo actually encoded — that
          // param skips the recommended combinations page. Hide Customize when
          // nothing is customizable rather than sending the customer into
          // an empty builder.
          if (encodedSelections) {
            var _this$customizer3;
            var searchParams = new URLSearchParams();
            searchParams.set('selections', encodedSelections);
            var variantId = (_this$customizer3 = this.customizer) === null || _this$customizer3 === void 0 || (_this$customizer3 = _this$customizer3.selectedVariant) === null || _this$customizer3 === void 0 ? void 0 : _this$customizer3.id;
            if (variantId) {
              searchParams.set('variant', String(variantId));
            }
            this.customizerUrlSearchParams = "?".concat(searchParams.toString());
          }
          if (!((_this$customizer4 = this.customizer) !== null && _this$customizer4 !== void 0 && _this$customizer4.canAddToCart)) {
            var _this$customizer$fill, _this$customizer5, _this$customizer$ingr, _this$customizer6, _this$customizer$ingr2, _this$customizer7;
            var errorMessage = 'This bundle cannot be added to the cart';
            var filledCount = (_this$customizer$fill = (_this$customizer5 = this.customizer) === null || _this$customizer5 === void 0 ? void 0 : _this$customizer5.filledSelections.length) !== null && _this$customizer$fill !== void 0 ? _this$customizer$fill : 0;
            var minRequiredCount = (_this$customizer$ingr = (_this$customizer6 = this.customizer) === null || _this$customizer6 === void 0 ? void 0 : _this$customizer6.ingredientLimits.min) !== null && _this$customizer$ingr !== void 0 ? _this$customizer$ingr : 0;
            var maxAllowedCount = (_this$customizer$ingr2 = (_this$customizer7 = this.customizer) === null || _this$customizer7 === void 0 ? void 0 : _this$customizer7.ingredientLimits.max) !== null && _this$customizer$ingr2 !== void 0 ? _this$customizer$ingr2 : 0;
            if (filledCount < minRequiredCount) errorMessage += '; <strong class="font-semibold">valid selections are below the minimum required count</strong>';
            if (filledCount > maxAllowedCount) errorMessage += '; <strong class="font-semibold">valid selections are above the maximum allowed count</strong>';
            handleInitError(errorMessage);
          }
        }
        window.dispatchEvent(new CustomEvent('intent:register', {
          detail: {
            intent: "add-bundle-".concat(this.blockId),
            handler: function handler() {
              return _this5.addToCart();
            }
          }
        }));
      }
    };
  });
};
function debugLog() {
  var _console;
  // eslint-disable-next-line no-console
  (_console = console).debug.apply(_console, arguments);
}
if (window.Alpine) {
  alpineInitialized = true;
  sectionStartup();
  registerCustomizerRecommendationsCard();
} else {
  document.addEventListener('alpine:init', function () {
    sectionStartup();
    registerCustomizerRecommendationsCard();
  });
}
})();

/******/ })()
;